<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 800 280">
    <defs>
        <style>
            .cls-1 {
                fill: #d3b598;
            }

            .cls-2 {
                fill: #262262;
            }

            .cls-3,
            .cls-52,
            .cls-71 {
                fill: #fff;
            }

            .cls-4,
            .cls-9 {
                fill: #ee2a7b;
            }

            .cls-5 {
                fill: #724014;
            }

            .cls-6 {
                fill: #c0e9ff;
            }

            .cls-7 {
                fill: #d4ffc2;
            }

            .cls-8 {
                fill: #c5ea7f;
            }

            .cls-9 {
                font-size: 31.1px;
                font-family: Ranchers-Regular, Ranchers;
                letter-spacing: 0.06em;
            }

            .cls-10 {
                letter-spacing: 0.08em;
            }

            .cls-11 {
                letter-spacing: 0.07em;
            }

            .cls-12 {
                letter-spacing: 0.08em;
            }

            .cls-13 {
                letter-spacing: 0.06em;
            }

            .cls-14 {
                letter-spacing: 0.06em;
            }

            .cls-15 {
                letter-spacing: 0.07em;
            }

            .cls-16 {
                fill: none;
                stroke: #c2b59b;
            }

            .cls-16,
            .cls-18,
            .cls-19 {
                stroke-miterlimit: 10;
            }

            .cls-17 {
                fill: #e8bc31;
            }

            .cls-18,
            .cls-31,
            .cls-35 {
                fill: #e6e7e8;
            }

            .cls-18,
            .cls-19 {
                stroke: #939598;
            }

            .cls-18 {
                stroke-width: 2px;
            }

            .cls-19 {
                fill: #c5edff;
                stroke-width: 0.5px;
            }

            .cls-20 {
                fill: #ca81ef;
            }

            .cls-21 {
                fill: #2b3990;
            }

            .cls-128,
            .cls-22 {
                fill: #414042;
            }

            .cls-23 {
                fill: #00aeef;
            }

            .cls-24,
            .cls-34,
            .cls-56,
            .cls-67 {
                fill: #231f20;
            }

            .cls-24,
            .cls-25 {
                opacity: 0.5;
            }

            .cls-26 {
                fill: #875213;
            }

            .cls-27 {
                fill: #eac6a9;
            }

            .cls-28 {
                fill: url(#linear-gradient);
            }

            .cls-29 {
                fill: url(#linear-gradient-2);
            }

            .cls-30 {
                fill: url(#linear-gradient-3);
            }

            .cls-31,
            .cls-32 {
                opacity: 0.8;
            }

            .cls-32 {
                fill: url(#linear-gradient-4);
            }

            .cls-33,
            .cls-37 {
                opacity: 0.3;
            }

            .cls-33 {
                fill: url(#linear-gradient-5);
            }

            .cls-36 {
                fill: #111a17;
            }

            .cls-37 {
                fill: url(#linear-gradient-6);
            }

            .cls-38 {
                fill: url(#linear-gradient-7);
            }

            .cls-39 {
                fill: #2e3641;
                opacity: 0.4;
            }

            .cls-40 {
                fill: #7b8793;
            }

            .cls-41 {
                fill: url(#linear-gradient-8);
            }

            .cls-42 {
                fill: #ef4136;
            }

            .cls-43 {
                fill: #39b54a;
            }

            .cls-44 {
                fill: #1c75bc;
            }

            .cls-45 {
                fill: #efb420;
            }

            .cls-46 {
                opacity: 0.75;
                fill: url(#linear-gradient-9);
            }

            .cls-47 {
                fill: url(#linear-gradient-10);
            }

            .cls-48 {
                fill: #58595b;
            }

            .cls-49 {
                fill: #808285;
            }

            .cls-50 {
                fill: url(#linear-gradient-11);
            }

            .cls-51 {
                fill: url(#linear-gradient-12);
            }

            .cls-52 {
                opacity: 0.62;
            }

            .cls-53,
            .cls-54 {
                fill: #493a56;
            }

            .cls-53 {
                opacity: 0.38;
            }

            .cls-55 {
                fill: url(#linear-gradient-13);
            }

            .cls-136,
            .cls-144,
            .cls-56 {
                opacity: 0.6;
            }

            .cls-57 {
                fill: url(#linear-gradient-14);
            }

            .cls-58 {
                fill: url(#linear-gradient-15);
            }

            .cls-59 {
                fill: url(#linear-gradient-16);
            }

            .cls-60 {
                fill: #be1e2d;
            }

            .cls-61 {
                fill: #f7941d;
            }

            .cls-62 {
                fill: #d8cf95;
            }

            .cls-63 {
                fill: #d1d3d4;
            }

            .cls-64 {
                fill: #fbb040;
            }

            .cls-65 {
                fill: #dbb5a1;
            }

            .cls-66 {
                fill: #ffc880;
            }

            .cls-67 {
                opacity: 0.25;
            }

            .cls-68 {
                fill: #d3c116;
            }

            .cls-69,
            .cls-72 {
                fill: #3c2415;
            }

            .cls-70 {
                fill: #8b5e3c;
            }

            .cls-71 {
                opacity: 0.05;
            }

            .cls-72 {
                opacity: 0.1;
            }

            .cls-73 {
                fill: #c49a6c;
            }

            .cls-74 {
                fill: #6d6e71;
            }

            .cls-75 {
                fill: url(#linear-gradient-17);
            }

            .cls-76 {
                fill: url(#linear-gradient-18);
            }

            .cls-77 {
                fill: url(#linear-gradient-19);
            }

            .cls-78 {
                fill: url(#linear-gradient-20);
            }

            .cls-79 {
                fill: url(#linear-gradient-21);
            }

            .cls-80 {
                fill: url(#linear-gradient-22);
            }

            .cls-81 {
                fill: url(#linear-gradient-23);
            }

            .cls-82 {
                fill: url(#linear-gradient-24);
            }

            .cls-83 {
                fill: url(#linear-gradient-25);
            }

            .cls-84 {
                fill: url(#linear-gradient-26);
            }

            .cls-85 {
                fill: url(#linear-gradient-27);
            }

            .cls-86 {
                fill: url(#linear-gradient-28);
            }

            .cls-87 {
                fill: url(#linear-gradient-29);
            }

            .cls-88 {
                fill: url(#linear-gradient-30);
            }

            .cls-89 {
                fill: url(#linear-gradient-31);
            }

            .cls-90 {
                fill: url(#linear-gradient-32);
            }

            .cls-91 {
                fill: url(#linear-gradient-33);
            }

            .cls-92 {
                fill: url(#linear-gradient-34);
            }

            .cls-93 {
                fill: url(#linear-gradient-35);
            }

            .cls-94 {
                fill: url(#linear-gradient-36);
            }

            .cls-95 {
                fill: url(#linear-gradient-37);
            }

            .cls-96 {
                fill: url(#linear-gradient-38);
            }

            .cls-97 {
                fill: url(#linear-gradient-39);
            }

            .cls-98 {
                fill: url(#linear-gradient-40);
            }

            .cls-99 {
                fill: url(#linear-gradient-41);
            }

            .cls-100 {
                fill: url(#linear-gradient-42);
            }

            .cls-101 {
                fill: url(#linear-gradient-43);
            }

            .cls-102 {
                fill: url(#linear-gradient-44);
            }

            .cls-103 {
                fill: url(#radial-gradient);
            }

            .cls-104 {
                fill: url(#radial-gradient-2);
            }

            .cls-105 {
                fill: url(#linear-gradient-45);
            }

            .cls-106 {
                fill: url(#linear-gradient-46);
            }

            .cls-107 {
                fill: url(#linear-gradient-47);
            }

            .cls-108 {
                fill: url(#linear-gradient-48);
            }

            .cls-109 {
                fill: url(#linear-gradient-49);
            }

            .cls-110 {
                fill: url(#linear-gradient-50);
            }

            .cls-111 {
                fill: url(#linear-gradient-51);
            }

            .cls-112 {
                fill: url(#linear-gradient-52);
            }

            .cls-113 {
                fill: url(#linear-gradient-53);
            }

            .cls-114 {
                fill: url(#linear-gradient-54);
            }

            .cls-115 {
                fill: url(#linear-gradient-55);
            }

            .cls-116 {
                fill: url(#linear-gradient-56);
            }

            .cls-117 {
                fill: url(#linear-gradient-57);
            }

            .cls-118 {
                fill: url(#linear-gradient-58);
            }

            .cls-119 {
                fill: url(#linear-gradient-59);
            }

            .cls-120 {
                fill: url(#linear-gradient-60);
            }

            .cls-121 {
                fill: url(#linear-gradient-61);
            }

            .cls-122 {
                fill: url(#linear-gradient-62);
            }

            .cls-123 {
                fill: url(#linear-gradient-63);
            }

            .cls-124 {
                fill: url(#White_Black_2);
            }

            .cls-125 {
                fill: url(#linear-gradient-64);
            }

            .cls-126 {
                fill: url(#linear-gradient-65);
            }

            .cls-127 {
                fill: url(#linear-gradient-66);
            }

            .cls-128 {
                font-size: 15.67px;
                font-family: SedgwickAveDisplay-Regular, Sedgwick Ave Display;
            }

            .cls-129 {
                fill: url(#linear-gradient-67);
            }

            .cls-130 {
                fill: url(#linear-gradient-68);
            }

            .cls-131 {
                fill: url(#linear-gradient-69);
            }

            .cls-132 {
                fill: url(#linear-gradient-70);
            }

            .cls-133 {
                fill: url(#linear-gradient-71);
            }

            .cls-134 {
                fill: url(#linear-gradient-72);
            }

            .cls-135 {
                fill: url(#linear-gradient-73);
            }

            .cls-136 {
                fill: url(#linear-gradient-74);
            }

            .cls-137 {
                fill: url(#linear-gradient-75);
            }

            .cls-138 {
                fill: url(#linear-gradient-76);
            }

            .cls-139 {
                fill: url(#linear-gradient-77);
            }

            .cls-140 {
                fill: url(#linear-gradient-78);
            }

            .cls-141 {
                fill: url(#linear-gradient-79);
            }

            .cls-142 {
                fill: url(#linear-gradient-80);
            }

            .cls-143 {
                fill: url(#linear-gradient-81);
            }

            .cls-144 {
                fill: url(#linear-gradient-82);
            }

            .cls-145 {
                fill: url(#linear-gradient-83);
            }

            .cls-146 {
                fill: url(#linear-gradient-84);
            }

            .cls-147 {
                fill: url(#linear-gradient-85);
            }

            .cls-148 {
                fill: url(#linear-gradient-86);
            }

            .cls-149 {
                fill: url(#linear-gradient-87);
            }

            .cls-150 {
                fill: url(#linear-gradient-88);
            }

            .cls-151 {
                fill: url(#linear-gradient-89);
            }

            .cls-152 {
                fill: url(#linear-gradient-90);
            }

            .cls-153 {
                fill: url(#linear-gradient-91);
            }

            .cls-154 {
                fill: url(#linear-gradient-92);
            }

            .cls-155 {
                fill: url(#linear-gradient-93);
            }

            .cls-156 {
                fill: url(#radial-gradient-3);
            }

            .cls-157 {
                fill: url(#linear-gradient-94);
            }

            .cls-158 {
                fill: url(#linear-gradient-95);
            }

            .cls-159 {
                fill: url(#linear-gradient-96);
            }

            .cls-160 {
                fill: url(#linear-gradient-97);
            }

            .cls-161 {
                fill: url(#linear-gradient-98);
            }

            .cls-162 {
                fill: url(#linear-gradient-99);
            }

            .cls-163 {
                fill: url(#linear-gradient-100);
            }

            .cls-164 {
                fill: url(#radial-gradient-4);
            }
        </style>
        <linearGradient id="linear-gradient" x1="1396.86" y1="88.26" x2="1408.06" y2="88.26"
            gradientTransform="matrix(-0.59, -0.05, -0.08, 1, 993, 29.67)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#9d8775" />
            <stop offset="0.29" stop-color="#bbbbbd" />
            <stop offset="1" stop-color="#c2cdcc" />
        </linearGradient>
        <linearGradient id="linear-gradient-2" x1="158.33" y1="69" x2="138.92" y2="57.8" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#c8c8c8" />
            <stop offset="1" stop-color="#aeadad" />
            <stop offset="1" />
        </linearGradient>
        <linearGradient id="linear-gradient-3" x1="256.94" y1="28.79" x2="258.25" y2="20.75"
            gradientTransform="translate(-205.49 -6.53) scale(1.37 2.2)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#e5e6e7" />
            <stop offset="0.54" stop-color="#cccacf" />
            <stop offset="1" stop-color="#f2f2f2" />
        </linearGradient>
        <linearGradient id="linear-gradient-4" x1="-172.95" y1="16.71" x2="-160.09" y2="16.71"
            gradientTransform="matrix(0.54, -0.04, 0.07, 0.93, 241.11, 31.02)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#9d8775" />
            <stop offset="0" stop-color="#aca198" />
            <stop offset="0.19" stop-color="#bbbbbd" />
            <stop offset="0.49" stop-color="#e6e7e8" />
            <stop offset="1" stop-color="#c2cdcc" />
        </linearGradient>
        <linearGradient id="linear-gradient-5" x1="-1016.74" y1="283.13" x2="-1003.86" y2="283.13"
            gradientTransform="matrix(0.23, 0.07, -0.1, 0.35, 417.43, 13.37)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#555853" />
            <stop offset="0.29" stop-color="#bbbbbd" />
            <stop offset="1" stop-color="#697782" />
        </linearGradient>
        <linearGradient id="linear-gradient-6" x1="-265.5" y1="-348.62" x2="-254.69" y2="-348.62"
            gradientTransform="matrix(0.34, -0.17, 0.2, 0.41, 304.73, 147.01)" xlink:href="#linear-gradient-5" />
        <linearGradient id="linear-gradient-7" x1="136.15" y1="48.55" x2="143.91" y2="48.55"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#9d8775" />
            <stop offset="0.29" stop-color="#bbbbbd" />
            <stop offset="0.55" stop-color="#bfbfc1" />
            <stop offset="1" stop-color="#fff" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient id="linear-gradient-8" x1="85.21" y1="-59.77" x2="88.47" y2="-60.12"
            gradientTransform="matrix(0.77, -0.21, 0.24, 0.89, 95.08, 116.45)" xlink:href="#linear-gradient-5" />
        <linearGradient id="linear-gradient-9" x1="429.62" y1="334.21" x2="446.87" y2="334.21"
            gradientTransform="translate(-161.05 297.06) rotate(-62.47)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="0.65" stop-color="#dddcdc" />
            <stop offset="1" stop-color="#c2c1c1" />
        </linearGradient>
        <linearGradient id="linear-gradient-10" x1="435.17" y1="332.69" x2="436.17" y2="332.69"
            xlink:href="#linear-gradient-9" />
        <linearGradient id="linear-gradient-11" x1="435.67" y1="332.7" x2="455.82" y2="332.7"
            xlink:href="#linear-gradient-9" />
        <linearGradient id="linear-gradient-12" x1="453.68" y1="332.7" x2="455.82" y2="332.7"
            gradientTransform="translate(-161.05 297.06) rotate(-62.47)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#dddcdc" />
            <stop offset="1" stop-color="#a7a6a6" />
            <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <linearGradient id="linear-gradient-13" x1="458.35" y1="332.65" x2="461.47" y2="332.65"
            xlink:href="#linear-gradient-9" />
        <linearGradient id="linear-gradient-14" x1="430.08" y1="329.27" x2="447.34" y2="329.27"
            xlink:href="#linear-gradient-12" />
        <linearGradient id="linear-gradient-15" x1="433.78" y1="336.27" x2="450.74" y2="336.27"
            xlink:href="#linear-gradient-9" />
        <linearGradient id="linear-gradient-16" x1="874.15" y1="-405.81" x2="890.02" y2="-405.81"
            gradientTransform="matrix(-0.43, 0.9, -0.9, -0.43, 344.15, -898.93)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#2484c6" />
            <stop offset="0.07" stop-color="#2484c6" stop-opacity="0.61" />
            <stop offset="0.54" stop-color="#2484c6" stop-opacity="0.18" />
            <stop offset="1" stop-color="#2484c6" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="linear-gradient-17" x1="-1215.47" y1="-388.08" x2="-1213.79" y2="-388.11"
            gradientTransform="matrix(1, 0, 0, -1, 1660.27, -162.95)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="0" stop-color="#d6d5d6" />
            <stop offset="1" stop-color="#737172" />
            <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <linearGradient id="linear-gradient-18" x1="-1489.33" y1="407.94" x2="-1488.17" y2="407.92"
            gradientTransform="matrix(1, 0, 0, -0.8, 1948.6, 547.88)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-19" x1="-191.31" y1="636.08" x2="-189.63" y2="636.05"
            gradientTransform="translate(659.24 -410.91)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-20" x1="-2849.99" y1="-1221.29" x2="-2848.66" y2="-1221.31"
            gradientTransform="translate(1341.91 603.75) scale(0.31)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-21" x1="707.1" y1="2335.8" x2="708.43" y2="2335.78"
            gradientTransform="matrix(0.31, 0, 0, -0.31, 239.84, 950.99)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-22" x1="-1353.23" y1="198.68" x2="-1351.19" y2="198.64"
            gradientTransform="matrix(1, 0, 0, -1, 1809.41, 397.32)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-23" x1="-1082.65" y1="262.44" x2="-1037" y2="262.44"
            gradientTransform="translate(-602.62 446.38) rotate(180)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="0" stop-color="#e1e0e0" />
            <stop offset="0" stop-color="#a2a0a0" />
            <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <linearGradient id="linear-gradient-24" x1="-1082.17" y1="266.03" x2="-1037.98" y2="266.03"
            gradientTransform="translate(-602.62 446.38) rotate(180)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#ed1c24" />
            <stop offset="0.5" stop-color="#741e22" />
            <stop offset="0.73" stop-color="#df1c24" />
            <stop offset="1" stop-color="#441f21" />
            <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <linearGradient id="linear-gradient-25" x1="-1082.65" y1="275.07" x2="-1037" y2="275.07"
            xlink:href="#linear-gradient-23" />
        <linearGradient id="linear-gradient-26" x1="-1081.52" y1="275.98" x2="-1038.13" y2="275.98"
            gradientTransform="translate(-602.62 446.38) rotate(180)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#d1d3d4" />
            <stop offset="1" stop-color="#e9e8e8" />
            <stop offset="1" stop-color="#cecdcd" />
            <stop offset="1" stop-color="#b1b0b0" />
            <stop offset="1" stop-color="#9b9999" />
        </linearGradient>
        <linearGradient id="linear-gradient-27" x1="-1060.07" y1="267.4" x2="-1059.58" y2="267.4"
            gradientTransform="translate(1517.03 -88.42)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-28" x1="-1060.85" y1="267.14" x2="-1058.8" y2="267.14"
            gradientTransform="translate(1517.03 -87.91)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-29" x1="-1076.46" y1="269.04" x2="-1075.97" y2="269.04"
            gradientTransform="translate(-602.62 446.38) rotate(180)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-30" x1="1179.22" y1="360.43" x2="1179.72" y2="360.43"
            gradientTransform="translate(-722.25 -173.77)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-31" x1="1178.46" y1="360.17" x2="1180.47" y2="360.17"
            gradientTransform="translate(-722.25 -173.77)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-32" x1="394.26" y1="269.07" x2="394.83" y2="269.07"
            gradientTransform="matrix(1, 0, 0, -1, 45.84, 446.38)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-33" x1="393.79" y1="268.74" x2="395.21" y2="268.74"
            gradientTransform="matrix(1, 0, 0, -1, 45.84, 446.38)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-34" x1="-1773.12" y1="268.74" x2="-1771.66" y2="268.74"
            gradientTransform="translate(-1298.8 446.38) rotate(180)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-35" x1="1195.57" y1="358.78" x2="1196.07" y2="358.78"
            gradientTransform="translate(-722.25 -173.77)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-36" x1="-1773.11" y1="261.73" x2="-1771.47" y2="261.73"
            gradientTransform="translate(-1298.8 446.38) rotate(180)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-37" x1="-1115.08" y1="358.78" x2="-1114.58" y2="358.78"
            gradientTransform="matrix(-1, 0, 0, 1, -674.57, -173.77)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-38" x1="537.65" y1="261.73" x2="539.07" y2="261.73"
            gradientTransform="matrix(1, 0, 0, -1, -98.02, 446.38)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-39" x1="-1121.97" y1="-294.58" x2="-1120.4" y2="-294.6"
            gradientTransform="matrix(1, 0, 0, -1, 1434.62, -69.4)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-40" x1="-1359.4" y1="371.29" x2="-1358.32" y2="371.27"
            gradientTransform="matrix(1, 0, 0, -0.8, 1685.57, 518.87)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-41" x1="-285.84" y1="541.55" x2="-284.27" y2="541.52"
            gradientTransform="translate(620.11 -316.35)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-42" x1="-2548.27" y1="-920.37" x2="-2547.03" y2="-920.39"
            gradientTransform="translate(1115.16 510.16) scale(0.31)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-43" x1="405.3" y1="2033.21" x2="406.54" y2="2033.19"
            gradientTransform="matrix(0.31, 0, 0, -0.31, 200.72, 856.88)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-44" x1="-1220.31" y1="193.58" x2="-1218.19" y2="193.55"
            gradientTransform="matrix(1, 0, 0, -1, 1543.49, 387.13)" xlink:href="#linear-gradient-17" />
        <radialGradient id="radial-gradient" cx="-1427" cy="-44.73" r="15.79"
            gradientTransform="matrix(1, 0, 0, -0.61, 1751.34, 133.55)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#3c2415" />
            <stop offset="1" stop-color="#a17938" />
            <stop offset="1" stop-color="#b88c40" />
        </radialGradient>
        <radialGradient id="radial-gradient-2" cx="-1219.34" cy="215.83" r="15.79"
            gradientTransform="matrix(-1, 0, 0, 0.61, -895.01, 24.11)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#f9efda" />
            <stop offset="1" stop-color="#b88c40" />
        </radialGradient>
        <linearGradient id="linear-gradient-45" x1="-975.73" y1="230.31" x2="-930.09" y2="230.31"
            xlink:href="#linear-gradient-23" />
        <linearGradient id="linear-gradient-46" x1="-975.01" y1="248.45" x2="-930.81" y2="248.45"
            xlink:href="#linear-gradient-24" />
        <linearGradient id="linear-gradient-47" x1="-975.73" y1="271.41" x2="-930.09" y2="271.41"
            xlink:href="#linear-gradient-23" />
        <linearGradient id="linear-gradient-48" x1="-974.61" y1="271.67" x2="-931.21" y2="271.67"
            xlink:href="#linear-gradient-26" />
        <linearGradient id="linear-gradient-49" x1="-953.16" y1="263.79" x2="-952.66" y2="263.79"
            gradientTransform="translate(1303.19 -81.2)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-50" x1="-954.21" y1="261.73" x2="-951.61" y2="261.73"
            gradientTransform="translate(1303.19 -77.08)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-51" x1="-969.55" y1="264.69" x2="-969.05" y2="264.69"
            gradientTransform="translate(-602.62 446.38) rotate(180)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-52" x1="-970.58" y1="262.64" x2="-967.98" y2="262.64"
            gradientTransform="translate(-602.62 446.38) rotate(180)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-53" x1="287.34" y1="264.69" x2="287.84" y2="264.69"
            gradientTransform="matrix(1, 0, 0, -1, 45.84, 446.38)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-54" x1="286.31" y1="262.64" x2="288.91" y2="262.64"
            gradientTransform="matrix(1, 0, 0, -1, 45.84, 446.38)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-55" x1="358.12" y1="114.34" x2="358.61" y2="114.34"
            gradientTransform="translate(-8.79 99.87)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-56" x1="357.06" y1="112.27" x2="359.67" y2="112.27"
            gradientTransform="translate(-8.79 99.87)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-57" x1="375.44" y1="113.5" x2="375.94" y2="113.5"
            gradientTransform="translate(-8.79 99.87)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-58" x1="374.41" y1="111.45" x2="377.02" y2="111.45"
            gradientTransform="translate(-8.79 99.87)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-59" x1="-990.98" y1="113.5" x2="-990.48" y2="113.5"
            gradientTransform="matrix(-1, 0, 0, 1, -657.26, 99.87)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-60" x1="-992.01" y1="111.45" x2="-989.41" y2="111.45"
            gradientTransform="matrix(-1, 0, 0, 1, -657.26, 99.87)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-61" x1="327.75" y1="222.65" x2="338.63" y2="222.47"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-62" x1="-922.55" y1="217.99" x2="-913.47" y2="217.85"
            gradientTransform="matrix(-1, 0, 0, 1, -543.98, 0)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-63" x1="445.08" y1="425.7" x2="449.67" y2="425.62"
            gradientTransform="matrix(0.79, -0.24, 0.29, 0.96, -134.38, -75.54)" xlink:href="#linear-gradient-17" />
        <linearGradient id="White_Black_2" x1="372.92" y1="207.36" x2="442.21" y2="207.36"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <linearGradient id="linear-gradient-64" x1="371" y1="207.36" x2="443.41" y2="207.36"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-24" />
        <linearGradient id="linear-gradient-65" x1="370.85" y1="217.98" x2="444.29" y2="217.98"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="0" stop-color="#e1e0e0" />
            <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <linearGradient id="linear-gradient-66" x1="373.3" y1="216.62" x2="441.83" y2="216.62"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-26" />
        <linearGradient id="linear-gradient-67" x1="37.33" y1="169.47" x2="37.64" y2="169.47"
            gradientTransform="matrix(3.29, 0.05, -0.02, 1.23, 263.8, -23.97)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-68" x1="37.06" y1="169" x2="37.92" y2="169"
            gradientTransform="matrix(3.29, 0.05, -0.02, 1.23, 263.8, -23.97)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-69" x1="51.01" y1="78.06" x2="51.32" y2="78.06"
            gradientTransform="matrix(3.29, -0.05, -0.02, -1.23, 263.8, 285.53)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-70" x1="50.74" y1="77.6" x2="51.6" y2="77.6"
            gradientTransform="matrix(3.29, -0.05, -0.02, -1.23, 263.8, 285.53)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-71" x1="363.67" y1="152.39" x2="403.9" y2="152.39"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-23" />
        <linearGradient id="linear-gradient-72" x1="364.31" y1="160.22" x2="403.26" y2="160.22"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-24" />
        <linearGradient id="linear-gradient-73" x1="363.67" y1="173.4" x2="403.9" y2="173.4"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-23" />
        <linearGradient id="linear-gradient-74" x1="364.66" y1="174.09" x2="402.91" y2="174.09"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#b1b0b0" />
            <stop offset="1" stop-color="#9b9999" />
        </linearGradient>
        <linearGradient id="linear-gradient-75" x1="372.83" y1="156.98" x2="373.27" y2="156.98"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#8c8a8b" />
            <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <linearGradient id="linear-gradient-76" x1="371.9" y1="156.98" x2="374.2" y2="156.98"
            xlink:href="#linear-gradient-75" />
        <linearGradient id="linear-gradient-77" x1="394.3" y1="156.98" x2="394.74" y2="156.98"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-78" x1="393.37" y1="156.98" x2="395.67" y2="156.98"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-79" x1="412.68" y1="151.91" x2="458.32" y2="151.91"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-23" />
        <linearGradient id="linear-gradient-80" x1="413.4" y1="160.52" x2="457.6" y2="160.52"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-24" />
        <linearGradient id="linear-gradient-81" x1="412.68" y1="175.03" x2="458.32" y2="175.03"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-23" />
        <linearGradient id="linear-gradient-82" x1="413.8" y1="175.79" x2="457.2" y2="175.79"
            xlink:href="#linear-gradient-74" />
        <linearGradient id="linear-gradient-83" x1="423.07" y1="156.95" x2="423.57" y2="156.95"
            xlink:href="#linear-gradient-75" />
        <linearGradient id="linear-gradient-84" x1="422.02" y1="156.95" x2="424.62" y2="156.95"
            xlink:href="#linear-gradient-75" />
        <linearGradient id="linear-gradient-85" x1="447.43" y1="156.95" x2="447.93" y2="156.95"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-86" x1="446.38" y1="156.95" x2="448.99" y2="156.95"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-87" x1="128.32" y1="837.11" x2="130" y2="837.09"
            gradientTransform="translate(346.75 -695.81)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-88" x1="73.55" y1="910.38" x2="75.23" y2="910.36"
            gradientTransform="translate(414.6 -678.54)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-89" x1="296.68" y1="-90.65" x2="297.83" y2="-90.66"
            gradientTransform="translate(177.52 301.79) scale(1 0.8)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-90" x1="-1489.78" y1="-652.95" x2="-1488.1" y2="-652.98"
            gradientTransform="matrix(1, 0, 0, -1, 1954.8, -421.14)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-91" x1="1317.52" y1="2915.92" x2="1318.85" y2="2915.9"
            gradientTransform="matrix(0.31, 0, 0, -0.31, 69.77, 1138.41)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-92" x1="-3430.11" y1="-1831.71" x2="-3428.78" y2="-1831.73"
            gradientTransform="translate(1542.77 800.61) scale(0.31)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-93" x1="476.12" y1="187.89" x2="478.72" y2="187.85"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-17" />
        <radialGradient id="radial-gradient-3" cx="463.89" cy="175.3" r="22.32"
            gradientTransform="translate(0 24.11) scale(1 0.61)" xlink:href="#radial-gradient-2" />
        <linearGradient id="linear-gradient-94" x1="-1086.3" y1="-377.37" x2="-1084.62" y2="-377.4"
            gradientTransform="matrix(1, 0, 0, -1, 1432.18, -236)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-95" x1="-1141.07" y1="-304.1" x2="-1139.39" y2="-304.13"
            gradientTransform="matrix(1, 0, 0, -1, 1473.87, -72.2)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-96" x1="-1378.6" y1="385.21" x2="-1377.44" y2="385.19"
            gradientTransform="matrix(1, 0, 0, -0.8, 1725.88, 536.54)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-97" x1="-275.29" y1="561.67" x2="-273.61" y2="561.64"
            gradientTransform="translate(631.23 -329.74)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-98" x1="-2580.45" y1="-982.48" x2="-2579.12" y2="-982.5"
            gradientTransform="translate(1145.94 536.12) scale(0.31)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-99" x1="468.3" y1="2066.27" x2="469.63" y2="2066.25"
            gradientTransform="matrix(0.31, 0, 0, -0.31, 202.25, 873.78)" xlink:href="#linear-gradient-17" />
        <linearGradient id="linear-gradient-100" x1="-1241.52" y1="187.98" x2="-1238.91" y2="187.94"
            gradientTransform="matrix(1, 0, 0, -1, 1585.42, 375.92)" xlink:href="#linear-gradient-17" />
        <radialGradient id="radial-gradient-4" cx="-1253.75" cy="175.46" r="16.9" xlink:href="#radial-gradient-2" />
    </defs>
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect id="Floor" class="cls-1" y="183.81" width="800" height="96.19" />
            <rect id="Wall" class="cls-2" width="800" height="183.49" />
            <rect id="Floor-2" data-name="Floor" class="cls-3" y="176.67" width="800" height="7.14" />
            <g id="Thank_You" data-name="Thank You">
                <path class="cls-4"
                    d="M48.59,74l.11-5.07c0-1.4,0-2.92.06-4.55L48.81,59q0-2.85,0-6.29V48.37c0-.85,0-1.66,0-2.41H43.73V35.78H63.19V46H58.11c0,2.3-.09,4.64-.11,7q0,4,0,8.72v7.86c0,.77,0,1.39,0,1.87s0,1,0,1.56v1Z" />
                <path class="cls-3"
                    d="M62.19,36.78V45H57.13Q57,48.91,57,53t0,8.73v7.86c0,.78,0,1.41,0,1.9s0,1,0,1.53H49.61q0-1.95.09-4t.06-4.56c0-1.64,0-3.41.05-5.31s0-4,0-6.3V48.37c0-1.24,0-2.38,0-3.41H44.73V36.78H62.19m2-2H42.73V47h5.09c0,.46,0,.93,0,1.41v4.38q0,3.44,0,6.29l-.05,5.3c0,1.63,0,3.14-.06,4.54l-.09,4,0,2H59V73c0-.56,0-1.08,0-1.59s0-1.09,0-1.84V61.68c0-3.1,0-6,0-8.71,0-2,0-4,.09-6h5.1V34.78Z" />
                <path class="cls-4"
                    d="M101.67,74l0-1c.06-1.76.1-3.61.13-5.53,0-1.66,0-3.53.08-5.6h-4.5c0,1.45,0,3,0,4.59q0,3,.07,6.56v1H88.18l.11-5,.09-4.37c0-1.56,0-3.27,0-5.12V48.08c0-1.46,0-2.79,0-4s0-2.39,0-3.53V35.78h9.48l0,1c-.12,2.43-.21,4.7-.27,6.77-.05,1.75-.09,3.51-.11,5.28h4.49V46.18c0-1.1,0-2.16,0-3.17s0-2,0-3v-4.2h9.48l0,1c-.09,1.85-.16,3.6-.2,5.25S111,45.34,111,47s0,3.22-.07,4.85,0,3.38,0,5.24q0,3.27,0,7.12c0,2.56,0,5.5.07,8.8v1Z" />
                <path class="cls-3"
                    d="M110.31,36.78c-.09,1.85-.16,3.61-.2,5.26s-.08,3.28-.11,4.89,0,3.23-.07,4.87,0,3.38,0,5.24c0,2.18,0,4.56,0,7.12s0,5.5.07,8.81h-7.3c.06-1.77.1-3.62.13-5.56s.06-4.13.09-6.61H96.41c0,1.74,0,3.61,0,5.6s0,4.18.07,6.57H89.2q0-1.95.09-4t.09-4.38c0-1.56,0-3.27,0-5.13V48.08c0-1.46,0-2.79,0-4s0-2.39,0-3.52V36.78h7.43c-.12,2.44-.21,4.71-.27,6.79s-.1,4.18-.13,6.3h6.51V46.18c0-1.11,0-2.17,0-3.19s0-2,0-3v-3.2h7.43m2.09-2H100.88V40c0,1,0,2,0,3s0,2.06,0,3.16v1.69H98.44c0-1.43.06-2.85.1-4.25.06-2.06.15-4.33.27-6.75l.1-2.09H87.38v5.78c0,1.14,0,2.32,0,3.54s0,2.53,0,4V59.47c0,1.81,0,3.53,0,5.1s-.06,3-.09,4.37l-.09,4,0,2H98.52l0-2q0-3.57-.07-6.56c0-1.24,0-2.44,0-3.58h2.49c0,1.67-.05,3.2-.07,4.58,0,1.91-.07,3.77-.13,5.52L100.63,75H112l0-2c0-3.3,0-6.24-.07-8.8s0-4.93,0-7.11c0-1.85,0-3.59,0-5.23s0-3.24.07-4.84.07-3.23.11-4.88.11-3.39.2-5.22l.09-2.09Z" />
                <path class="cls-4"
                    d="M152.07,74,151,66.71h-5L144.87,74h-9.54l6.87-38.19h12.54L161.56,74Zm-2.59-17.18-1-6.88-1,6.88Z" />
                <path class="cls-3"
                    d="M153.9,36.78,160.36,73h-7.43l-1.1-7.26h-6.77L144,73h-7.47L143,36.78H153.9m-7.65,21h4.4l-2.2-14.6-2.2,14.6m9.32-23h-14.2l-.3,1.64-6.51,36.19L134.14,75h11.59l.25-1.72.81-5.54h3.32l.84,5.56.26,1.7h11.54l-.42-2.36-6.46-36.19-.3-1.64Z" />
                <path class="cls-4"
                    d="M199.45,74l-7.66-17.79V74h-8l0-1q.09-4.56.13-9t.05-9c0-3,0-6-.05-9s-.07-6-.13-9l0-1h10.58l7,17.41V35.78h8.3v1c-.09,6-.14,12.07-.14,18.08s0,12.1.14,18.08v1Z" />
                <path class="cls-3"
                    d="M208.6,36.78q-.14,9-.14,18.09T208.6,73h-8.49l-9.32-21.64V73h-6q.09-4.56.13-9t.05-9.05c0-3,0-6-.05-9s-.07-6-.13-9h8.88l8.67,21.59V36.78h6.29m2-2H200.31V48L195.5,36l-.5-1.25H182.72l0,2c.06,3,.1,6.06.13,9s.05,6.06.05,9,0,6-.05,9-.07,6-.13,9l0,2h10.07V61l5.48,12.73.52,1.21h11.84l0-2c-.09-6-.14-12.06-.14-18.07s0-12.09.14-18.07l0-2Z" />
                <path class="cls-4"
                    d="M248.86,74,242,59.52c0,1.27,0,2.6,0,4l0,4.69q0,2.42,0,4.77v1h-9.77l.11-5.07q0-2.1.09-4.56c0-1.63.05-3.39.05-5.29V47.64c0-1.4,0-2.67,0-3.82s0-2.27,0-3.35V35.78h9.92l0,1c-.09,1.76-.15,3.32-.19,4.67s-.09,2.65-.11,3.88S242,47.89,242,49.2v.27l6.34-13.74h10.42l-9.1,18.65L259.33,74Z" />
                <path class="cls-3"
                    d="M257.19,36.73l-8.62,17.65L257.72,73H249.5l-8.32-17.52H241v3.71c0,1.39,0,2.84,0,4.36s0,3.08,0,4.69,0,3.19,0,4.76h-7.74c0-1.3,0-2.65.08-4s.06-2.92.09-4.56.05-3.41.05-5.31V47.64c0-1.4,0-2.68,0-3.83s0-2.26,0-3.34V36.78h7.87c-.08,1.76-.15,3.33-.19,4.68s-.09,2.66-.11,3.9-.06,2.51-.07,3.83,0,2.81,0,4.49h.17l7.83-17h8.18m3.2-2H247.73l-.53,1.16-4.09,8.84c0-1,.06-2.09.09-3.2.05-1.34.11-2.91.2-4.66l.11-2.09h-12v5.69c0,1.08,0,2.21,0,3.37s0,2.41,0,3.8V59.05c0,1.86,0,3.63-.05,5.28s-.06,3.15-.09,4.55l-.08,4-.05,2H243.1V73c0-1.57,0-3.16,0-4.78L243,64l4.66,9.81.54,1.15h12.7l-1.42-2.89-8.71-17.7L259,37.61l1.4-2.88Z" />
                <path class="cls-4"
                    d="M334.06,74l0-1q.09-2.88.13-6t.09-7.07l-9-24.09h9.46L339,48.65l4.24-12.87h9.42l-9,24.09v9.67c0,.77,0,1.39,0,1.87s0,1,0,1.56v1Z" />
                <path class="cls-3"
                    d="M351.23,36.78l-8.58,22.91v9.85c0,.78,0,1.41,0,1.9s0,1,0,1.53h-7.61q.09-2.88.13-6t.09-7.26l-8.53-22.91h7.3L339,51.86l5-15.08h7.26m2.88-2H342.52l-.45,1.37L339,45.44l-3-9.29-.45-1.37H323.9l1,2.69L333.3,60q0,3.89-.08,6.88c0,2.08-.07,4.1-.13,6L333,75H344.7V73c0-.56,0-1.08,0-1.59s0-1.09,0-1.84V60.06l8.45-22.58,1-2.7Z" />
                <path class="cls-4"
                    d="M387.39,74.45a13.25,13.25,0,0,1-6.18-1.37,11.75,11.75,0,0,1-4.38-4,18.36,18.36,0,0,1-2.47-6.27,40,40,0,0,1-.77-8.24c0-6.22,1.11-11,3.29-14.25s5.81-5.07,10.51-5.07,8.23,1.73,10.5,5.14,3.29,8,3.29,14.18S400.1,65.65,398,69.07C395.75,72.64,392.19,74.45,387.39,74.45Zm0-28.84a3.36,3.36,0,0,0-1.89.51A5.15,5.15,0,0,0,384,47.69a8.3,8.3,0,0,0-1,2.5,16.51,16.51,0,0,0,0,6.52,7.36,7.36,0,0,0,.95,2.38,4.67,4.67,0,0,0,1.44,1.46,3.54,3.54,0,0,0,1.92.49,3.82,3.82,0,0,0,2-.5,4.22,4.22,0,0,0,1.44-1.44,7.65,7.65,0,0,0,.93-2.39,14.83,14.83,0,0,0,.33-3.25,15.47,15.47,0,0,0-.33-3.31,8.52,8.52,0,0,0-.94-2.51,4.31,4.31,0,0,0-1.44-1.52A3.63,3.63,0,0,0,387.39,45.61Z" />
                <path class="cls-3"
                    d="M387.39,36.24q6.54,0,9.67,4.69t3.12,13.63q0,9.07-3.05,14t-9.74,4.91a12.22,12.22,0,0,1-5.72-1.26,10.56,10.56,0,0,1-4-3.67,17,17,0,0,1-2.33-5.93,38.68,38.68,0,0,1-.75-8q0-9.06,3.12-13.69t9.68-4.63m0,25.8a4.84,4.84,0,0,0,2.48-.64,5.28,5.28,0,0,0,1.78-1.77,8.7,8.7,0,0,0,1.06-2.7,16.24,16.24,0,0,0,.35-3.47,16.8,16.8,0,0,0-.35-3.52,9.51,9.51,0,0,0-1.06-2.81,5.22,5.22,0,0,0-1.78-1.86,4.67,4.67,0,0,0-2.48-.66,4.26,4.26,0,0,0-2.44.68,5.9,5.9,0,0,0-1.76,1.88A9,9,0,0,0,382.11,50a16,16,0,0,0-.35,3.48,15.63,15.63,0,0,0,.35,3.47,8,8,0,0,0,1.08,2.7A5.61,5.61,0,0,0,385,61.4a4.57,4.57,0,0,0,2.44.64m0-27.8c-5.06,0-8.87,1.86-11.34,5.51-2.33,3.45-3.46,8.3-3.46,14.81a41.37,41.37,0,0,0,.79,8.45A19.38,19.38,0,0,0,376,69.62,12.65,12.65,0,0,0,380.74,74a14.36,14.36,0,0,0,6.65,1.48c5.17,0,9-2,11.43-5.85,2.23-3.58,3.36-8.64,3.36-15S401,43.27,398.73,39.83c-2.47-3.71-6.29-5.59-11.34-5.59Zm0,25.8A2.56,2.56,0,0,1,386,59.7a3.49,3.49,0,0,1-1.13-1.16,6.19,6.19,0,0,1-.81-2,14.08,14.08,0,0,1-.3-3,14.54,14.54,0,0,1,.3-3.05,7.11,7.11,0,0,1,.84-2.2A3.78,3.78,0,0,1,386.05,47a2.32,2.32,0,0,1,1.34-.35,2.71,2.71,0,0,1,1.43.36,3.38,3.38,0,0,1,1.11,1.17,7.61,7.61,0,0,1,.82,2.22,14.28,14.28,0,0,1,.31,3.1,14.08,14.08,0,0,1-.3,3,6.84,6.84,0,0,1-.81,2.08,3.34,3.34,0,0,1-1.1,1.11,2.82,2.82,0,0,1-1.46.36Z" />
                <path class="cls-4"
                    d="M435.33,74.45a15,15,0,0,1-5.16-.79,11.08,11.08,0,0,1-3.69-2.17,10.4,10.4,0,0,1-2.41-3.25,18.28,18.28,0,0,1-1.32-3.86,25.82,25.82,0,0,1-.6-4.18c-.09-1.4-.13-2.82-.13-4.22,0-1.1,0-2.28,0-3.52s.08-2.64.14-4.18l.47-12.5h9.74S432,46.94,432,48.18s-.07,2.21-.09,2.93,0,1.29,0,1.68,0,.62,0,.78v.37a15.58,15.58,0,0,0,.88,6.05,2.48,2.48,0,0,0,2.56,1.58,2.42,2.42,0,0,0,2.52-1.7,20.5,20.5,0,0,0,.83-6.77v-.51c0-.18,0-.47,0-.87s0-1,0-1.67-.05-1.61-.09-2.77-.41-11.5-.41-11.5l9.94-.05v1c.06,4.28.15,8,.26,11.15s.18,5.85.18,8.06c0,1.46-.05,2.93-.13,4.38a26.21,26.21,0,0,1-.6,4.25,17.57,17.57,0,0,1-1.33,3.82,10.88,10.88,0,0,1-2.37,3.2,10.53,10.53,0,0,1-3.67,2.13A15.56,15.56,0,0,1,435.33,74.45Z" />
                <path class="cls-3"
                    d="M447,36.73q.09,6.47.26,11.17t.18,8c0,1.45,0,2.89-.13,4.32a26.34,26.34,0,0,1-.57,4.09,16.62,16.62,0,0,1-1.26,3.6,9.66,9.66,0,0,1-2.15,2.9A9.35,9.35,0,0,1,440,72.77a14.64,14.64,0,0,1-4.71.68,14,14,0,0,1-4.81-.73,9.87,9.87,0,0,1-3.37-2A9.22,9.22,0,0,1,425,67.81a17.08,17.08,0,0,1-1.26-3.65,26.3,26.3,0,0,1-.57-4c-.09-1.39-.13-2.78-.13-4.16,0-1.09,0-2.26,0-3.5s.08-2.62.14-4.16.12-3.24.19-5.13.16-4,.24-6.41h7.75q-.13,4-.23,6.74c0,1.85-.11,3.39-.15,4.63s-.07,2.22-.09,2.94,0,1.27,0,1.66,0,.65,0,.82v.37a16.67,16.67,0,0,0,1,6.46,3.5,3.5,0,0,0,3.48,2.17,3.39,3.39,0,0,0,3.45-2.35,21.07,21.07,0,0,0,.9-7.12v-.51c0-.19,0-.49,0-.9s0-1,0-1.66-.05-1.63-.09-2.79-.1-2.6-.16-4.29-.13-3.76-.22-6.17l7.92-.05m2-2h-2l-7.92.05H437l.08,2.06c.08,2.42.16,4.47.22,6.17s.11,3.13.15,4.29.07,2.08.09,2.76,0,1.27,0,1.69,0,.66,0,.83v.51a18.86,18.86,0,0,1-.77,6.41,1.43,1.43,0,0,1-1.58,1.06,1.52,1.52,0,0,1-1.65-1,14.51,14.51,0,0,1-.79-5.65v-.37c0-.15,0-.4,0-.74s0-1,0-1.7,0-1.69.09-2.91.09-2.79.15-4.63.14-4.1.22-6.75l.07-2.06H421.71l-.07,1.92q-.13,3.59-.25,6.41l-.19,5.14c-.06,1.53-.11,2.94-.14,4.19s0,2.39,0,3.54c0,1.42.05,2.86.14,4.28a27.66,27.66,0,0,0,.61,4.34,19.73,19.73,0,0,0,1.4,4.07,11.25,11.25,0,0,0,2.64,3.56,11.92,11.92,0,0,0,4,2.37,16,16,0,0,0,5.5.85,16.4,16.4,0,0,0,5.36-.79,11.46,11.46,0,0,0,4-2.35,11.85,11.85,0,0,0,2.59-3.48,18.81,18.81,0,0,0,1.41-4,28.23,28.23,0,0,0,.61-4.41c.09-1.47.14-3,.14-4.44,0-2.22-.06-5-.18-8.1S449.09,41,449,36.7l0-2Z" />
            </g>
            <g id="Window">
                <rect class="cls-5" x="545.85" y="25.72" width="232.85" height="112.6" />
                <polygon class="cls-6"
                    points="553.87 31.02 553.87 76.18 553.87 133.2 771.4 133.2 771.4 60.26 771.4 31.02 553.87 31.02" />
                <path class="cls-7" d="M771.4,58.42v7.52L553.87,76.18v-22C609.76,52.37,686,58.68,771.4,58.42Z" />
                <path class="cls-8" d="M771.4,60.26V133.2H553.87v-57C609.76,67.41,686,61.54,771.4,60.26Z" /><text
                    class="cls-9" transform="translate(612.26 74.56)">F<tspan class="cls-10" x="14.37" y="0">o</tspan>
                    <tspan class="cls-11" x="31.76" y="0">r</tspan>
                    <tspan class="cls-12" x="43.58" y="0"> </tspan>
                    <tspan class="cls-13" x="49.92" y="0"> </tspan>
                    <tspan class="cls-14" x="55.58" y="0">y</tspan>
                    <tspan class="cls-10" x="71.48" y="0">ou</tspan>
                    <tspan class="cls-15" x="105.63" y="0">r</tspan>
                    <tspan class="cls-12">
                        <tspan x="-22.46" y="37.33">feedback</tspan>
                    </tspan>
                </text>
                <g id="Window_Glass" data-name="Window Glass">
                    <rect class="cls-6" x="553.87" y="31.02" width="217.53" height="102.18" />
                    <polygon class="cls-3"
                        points="632.67 133.2 618.03 133.2 553.87 35.02 553.87 31.02 565.89 31.02 632.67 133.2" />
                    <polygon class="cls-3" points="710.44 133.2 665.6 133.2 598.83 31.02 643.67 31.02 710.44 133.2" />
                    <polygon class="cls-3" points="733.46 133.2 718.83 133.2 652.05 31.02 666.69 31.02 733.46 133.2" />
                    <polygon class="cls-3"
                        points="771.4 72.24 771.4 133.2 766.4 133.2 699.63 31.02 744.46 31.02 771.4 72.24" />
                </g>
                <polygon id="Window_Frame" data-name="Window Frame" class="cls-5"
                    points="771.4 79.54 664.98 79.54 664.98 30.73 659.42 30.73 659.42 79.54 553.15 79.54 553.15 84.54 659.42 84.54 659.42 133.3 664.98 133.3 664.98 84.54 771.4 84.54 771.4 79.54" />
            </g>
            <g id="Pic_T" data-name="Pic T">
                <g id="Frame_T" data-name="Frame T">
                    <polyline class="cls-16" points="35.6 26.44 51.05 11.39 66.49 26.44" />
                    <circle class="cls-17" cx="51.04" cy="13.77" r="1.4" />
                    <rect class="cls-18" x="29.47" y="25.77" width="43.15" height="58.58" />
                    <rect class="cls-19" x="35.6" y="32.28" width="30.89" height="45.56" />
                    <g id="Cat">
                        <path class="cls-20"
                            d="M60.83,61.58c-2.74-3.17-2.12-5.16-1.86-5.69a1.6,1.6,0,0,1,1.51-1,1.33,1.33,0,1,0,.11-2.65,4.26,4.26,0,0,0-4,2.48c-1.16,2.4-.33,5.61,2.23,8.57a2.41,2.41,0,0,1,.66,2.56,2.89,2.89,0,0,1-2.57,1.52h0a2.53,2.53,0,0,1-2.21-1.26,7,7,0,0,0,.25-1.84V60.47a7.14,7.14,0,0,0-3.36-6,4.85,4.85,0,0,0-.67-8.31l-1.13-4.6-1.72,4.09h-2l-1-4L42.92,46.7a4.86,4.86,0,0,0,.24,7.73,7.14,7.14,0,0,0-3.36,6v3.82a7.15,7.15,0,0,0,7.13,7.13h.88a7.14,7.14,0,0,0,5.6-2.73A5,5,0,0,0,56.9,70h0a5.48,5.48,0,0,0,5-3.06A5,5,0,0,0,60.83,61.58Z" />
                        <circle class="cls-21" cx="48.76" cy="50.62" r="1.07" />
                        <circle class="cls-21" cx="44.34" cy="50.62" r="1.07" />
                        <path class="cls-22"
                            d="M46.77,52.74c-.08.08,0,.31-.15.3s0-.23-.11-.3-.27-.21-.12-.35a.38.38,0,0,1,.54,0C47.08,52.53,46.92,52.59,46.77,52.74Z" />
                        <path class="cls-23"
                            d="M49,50.62a2.34,2.34,0,0,1-.2.93,2.34,2.34,0,0,1-.2-.93,2.41,2.41,0,0,1,.2-.93A2.41,2.41,0,0,1,49,50.62Z" />
                        <path class="cls-23"
                            d="M44.46,50.62a2.34,2.34,0,0,1-.2.93,2.34,2.34,0,0,1-.2-.93,2.41,2.41,0,0,1,.2-.93A2.41,2.41,0,0,1,44.46,50.62Z" />
                        <polygon class="cls-22"
                            points="49.53 53.26 47.71 52.97 49.52 52.97 49.52 52.89 47.22 52.89 47.22 53.01 49.41 53.7 49.43 53.62 47.85 53.1 49.52 53.34 49.53 53.26" />
                        <polygon class="cls-22"
                            points="43.71 53.26 45.53 52.97 43.73 52.97 43.73 52.89 46.02 52.89 46.03 53.01 43.84 53.7 43.81 53.62 45.4 53.1 43.73 53.34 43.71 53.26" />
                        <path class="cls-24" d="M44.87,43.4c-.21.37-1.16,2.88-1.16,2.88l1-.51Z" />
                        <path class="cls-24" d="M49.42,43c.19.36,1.07,2.87,1.07,2.87l-.94-.51Z" />
                    </g>
                    <g id="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="66.49 72.02 66.49 77.84 48.13 77.84 35.6 62.86 35.6 35.1 66.49 72.02" />
                        <polygon class="cls-3" points="66.49 57.77 66.49 66.83 37.59 32.28 45.17 32.28 66.49 57.77" />
                        <polygon class="cls-3" points="66.49 32.28 66.49 37.37 62.23 32.28 66.49 32.28" />
                    </g>
                </g>
            </g>
            <g id="Pic_H" data-name="Pic H">
                <g id="Frame_H" data-name="Frame H">
                    <polyline class="cls-16" points="84.31 26.44 99.76 11.39 115.2 26.44" />
                    <circle class="cls-17" cx="99.76" cy="13.77" r="1.4" />
                    <rect class="cls-18" x="78.18" y="25.77" width="43.15" height="58.58" />
                    <rect class="cls-19" x="84.31" y="32.28" width="30.89" height="45.56" />
                    <g id="Dude">
                        <rect class="cls-22" x="89.87" y="53.88" width="19.76" height="18.11" rx="4.96" />
                        <ellipse class="cls-26" cx="99.76" cy="45.34" rx="6.68" ry="7.14" />
                        <path class="cls-27"
                            d="M106.43,48.15a6.69,6.69,0,1,1-13.35,0c0-3.94,3-2.81,6.68-2.81S106.43,44.21,106.43,48.15Z" />
                    </g>
                    <g id="Glass-2" data-name="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="115.2 72.02 115.2 77.84 96.84 77.84 84.31 62.86 84.31 35.1 115.2 72.02" />
                        <polygon class="cls-3" points="115.2 57.77 115.2 66.83 86.3 32.28 93.88 32.28 115.2 57.77" />
                        <polygon class="cls-3" points="115.2 32.28 115.2 37.37 110.94 32.28 115.2 32.28" />
                    </g>
                </g>
            </g>
            <g id="Pic_A" data-name="Pic A">
                <g id="Frame_A" data-name="Frame A">
                    <polyline class="cls-16" points="133 26.44 148.45 11.39 163.89 26.44" />
                    <circle class="cls-17" cx="148.45" cy="13.77" r="1.4" />
                    <rect class="cls-18" x="126.87" y="25.77" width="43.15" height="58.58" />
                    <rect class="cls-19" x="133" y="32.28" width="30.89" height="45.56" />
                    <g id="Dog">
                        <path id="Left_ear" data-name="Left ear" class="cls-28"
                            d="M152.22,40.69c1.48,1.33,4.91,4.36,5.59,9.41a7.28,7.28,0,0,1-.16,3.67,42.64,42.64,0,0,1-2.64,4c-.37.58-1.83.14-2-.65s.44-1.88.58-3.58,1.1-5.94.63-7.2a5.1,5.1,0,0,0-1.44-2Z" />
                        <path class="cls-29"
                            d="M157.46,59.58c.87,6.65.55,14.94-4.65,14.94-6.78,0-10.24,1.63-12.78-4.77-2.23-5.6.08-19.19,5.26-19.75S156.68,53.6,157.46,59.58Z" />
                        <ellipse class="cls-30" cx="147.35" cy="47.84" rx="8.32" ry="8.79"
                            transform="translate(-4.28 16.07) rotate(-6.15)" />
                        <path class="cls-31"
                            d="M156.58,53.76c-.29,2.89-.62,2.92-3.86,3.25-4.51.46-6.65,0-6.69-3.18,0-2.12,2.06-4.57,5.32-4.74C155.34,48.88,156.8,51.65,156.58,53.76Z" />
                        <path class="cls-32"
                            d="M155.83,53.65c.17,2.18-1.23,3-3.11,3.36a3.12,3.12,0,0,1-3.84-2.83,3.51,3.51,0,1,1,7-.53Z" />
                        <path class="cls-33"
                            d="M154.81,47.81c-.22.79-1.39.94-2.17.72a1.34,1.34,0,0,1-.77-1.81,1.23,1.23,0,0,1,1.57-1A2.06,2.06,0,0,1,154.81,47.81Z" />
                        <g id="Nose">
                            <path class="cls-22"
                                d="M152.59,50.88c-.37.06-1.3-.07-1.46.36s-.51,1.06-.18,1.48.61.85,1,.94.49.35.91.3.46-.18.76-.39,1-1,1-1.42a2.48,2.48,0,0,0-1.4-1.27Z" />
                            <ellipse class="cls-34" cx="152.43" cy="52.53" rx="0.48" ry="0.33"
                                transform="translate(-8.46 42.12) rotate(-15.31)" />
                            <ellipse class="cls-34" cx="154.22" cy="52.38" rx="0.42" ry="0.27"
                                transform="translate(-2.9 95.27) rotate(-34.03)" />
                        </g>
                        <g id="Eye">
                            <ellipse class="cls-34" cx="147.44" cy="47.83" rx="1.27" ry="1.03"
                                transform="translate(-6.31 67.5) rotate(-25.26)" />
                            <ellipse class="cls-35" cx="147.57" cy="47.76" rx="1.24" ry="0.93"
                                transform="translate(-7.11 59.25) rotate(-22.18)" />
                            <path class="cls-36"
                                d="M147,48c.09.5.6.94,1,.67s.79-.64.71-1.14a.82.82,0,0,0-1-.67A1,1,0,0,0,147,48Z" />
                        </g>
                        <g id="Eye-2" data-name="Eye">
                            <path class="cls-34"
                                d="M153.59,47c.16-.49,0-.73-.63-.87s-.93.09-1.09.58-.22.6.35,1.12S153.44,47.5,153.59,47Z" />
                            <path class="cls-35"
                                d="M153.52,47c.12-.38,0-.63-.6-.77s-.79-.06-.86.48.1.48.44.9S153.41,47.4,153.52,47Z" />
                            <path class="cls-36"
                                d="M153.18,47.07c.13-.43-.06-1-.5-.94s-.67.15-.81.59.23.66.34,1,.84-.19,1-.62" />
                        </g>
                        <path class="cls-37"
                            d="M148.64,46.84a2.09,2.09,0,0,1-1.24,2.65c-1.13.56-1.65.69-2.09-.22s-.65-2.5.48-3.05A2.09,2.09,0,0,1,148.64,46.84Z" />
                        <path id="Left_ear-2" data-name="Left ear" class="cls-38"
                            d="M143.69,40.16c-2.67,1.21-6.61,6.32-7.09,8.6-.37,1.79-.66,2.85-.24,3.66a47.34,47.34,0,0,0,3.87,4.21c.55.6,3.05.29,3.46-.49s-.49-1.9-.49-3.61-1-6-.06-7.23.74-1.63.74-1.63a6.48,6.48,0,0,0-.66-1.47C142.9,41.73,143.69,40.16,143.69,40.16Z" />
                        <path class="cls-39"
                            d="M154.62,55.3s.21-.19.13-.09-.2.22-.72,0a3.55,3.55,0,0,0-2,.17c-.9.21-1.48,1.16-2.11.76.52.08,1.43-1.14,2.45-1.13.61,0,.42-1.06.42-1.06s.16-.09.15,0a1,1,0,0,0,.8,1C154.32,55,154.42,55.34,154.62,55.3Z" />
                        <path class="cls-40"
                            d="M153.89,44.59a.34.34,0,0,1,0,.1h0c-.09-.45-.69-.8-1.41-.8a1.48,1.48,0,0,0-1.36.65.5.5,0,0,1,0-.12s0-.07,0-.1a1.49,1.49,0,0,1,1.37-.66C153.25,43.67,153.89,44.08,153.89,44.59Z" />
                        <path class="cls-41"
                            d="M148.35,44.75s0,.07,0,.1h0c-.05-.11-.24,0-.29-.12a.72.72,0,0,0-.84-.3,5.52,5.52,0,0,0-1.57.58c.09-.34,1.35-.83,1.85-1A1,1,0,0,1,148.35,44.75Z" />
                    </g>
                    <g id="Glass-3" data-name="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="163.89 72.02 163.89 77.84 145.53 77.84 133 62.86 133 35.1 163.89 72.02" />
                        <polygon class="cls-3"
                            points="163.89 57.77 163.89 66.83 134.99 32.28 142.57 32.28 163.89 57.77" />
                        <polygon class="cls-3" points="163.89 32.28 163.89 37.37 159.63 32.28 163.89 32.28" />
                    </g>
                </g>
            </g>
            <g id="Pic_N" data-name="Pic N">
                <g id="Frame_N" data-name="Frame N">
                    <polyline class="cls-16" points="180.62 26.44 196.07 11.39 211.51 26.44" />
                    <circle class="cls-17" cx="196.07" cy="13.77" r="1.4" />
                    <rect class="cls-18" x="174.49" y="25.77" width="43.15" height="58.58" />
                    <rect class="cls-19" x="180.62" y="32.28" width="30.89" height="45.56" />
                    <g id="Dude-2" data-name="Dude">
                        <path class="cls-42"
                            d="M204.77,73.14h-9.72C192.76,73.14,191,63,191,60.91l0-6.28A5,5,0,0,1,195,50l9.76-2.06c3.2-.68,6,1,6,3.68v8.17C210.77,62.48,208,73.14,204.77,73.14Z" />
                        <path class="cls-26"
                            d="M206.71,39.31c0,3.77-3.36,7.61-7.18,8.5-3.46.8-6.06-1.16-6.09-4.31s2.54-6.76,6-8.15C203.28,33.82,206.7,35.53,206.71,39.31Z" />
                        <path class="cls-27"
                            d="M206.77,42c0,3.77-3.39,7.48-7.21,8.23-3.47.67-6.06-1.38-6.07-4.53s2.57-3.06,6-4.14C203.36,40.39,206.77,38.25,206.77,42Z" />
                    </g>
                    <g id="Dude-3" data-name="Dude">
                        <path class="cls-43"
                            d="M186.32,73.14h8.07c1.89,0,3.36-5.92,3.37-7.65l0-5.2a4.19,4.19,0,0,0-3.35-3.87l-8.09-1.7c-2.66-.56-5,.79-5,3.05v6.78C181.35,66.79,183.67,73.14,186.32,73.14Z" />
                        <path class="cls-26"
                            d="M184.69,50.71c0,3.13,2.81,3.18,6,3.91,2.87.67,5-.95,5.05-3.57s-1.9-6.42-5-6.76C185.06,43.67,184.71,47.57,184.69,50.71Z" />
                        <path class="cls-27"
                            d="M186.46,52.41c0,3.12,1,3.62,4.19,4.24,2.87.56,5-1.14,5-3.76s-2.13-2.53-5-3.43C187.49,48.47,186.47,49.27,186.46,52.41Z" />
                    </g>
                    <g id="Glass-4" data-name="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="211.51 72.02 211.51 77.84 193.15 77.84 180.62 62.86 180.62 35.1 211.51 72.02" />
                        <polygon class="cls-3"
                            points="211.51 57.77 211.51 66.83 182.61 32.28 190.19 32.28 211.51 57.77" />
                        <polygon class="cls-3" points="211.51 32.28 211.51 37.37 207.25 32.28 211.51 32.28" />
                    </g>
                </g>
            </g>
            <g id="Pic_K" data-name="Pic K">
                <g id="Frame_K" data-name="Frame K">
                    <polyline class="cls-16" points="230.09 26.44 245.54 11.39 260.99 26.44" />
                    <circle class="cls-17" cx="245.54" cy="13.77" r="1.4" />
                    <rect class="cls-18" x="223.96" y="25.77" width="43.15" height="58.58" />
                    <rect class="cls-19" x="230.09" y="32.28" width="30.89" height="45.56" />
                    <g id="Dude-4" data-name="Dude">
                        <path class="cls-44"
                            d="M238.1,62.29H253a4.17,4.17,0,0,1,4.17,4.17V69a7,7,0,0,1-7,7H235.72a1.78,1.78,0,0,1-1.78-1.78V66.46A4.17,4.17,0,0,1,238.1,62.29Z" />
                        <path class="cls-45"
                            d="M253.38,48.15c0,6.54-3.51,11.84-7.84,11.84s-7.84-5.3-7.84-11.84,3.51-7,7.84-7S253.38,41.61,253.38,48.15Z" />
                        <path class="cls-27"
                            d="M253.38,52.81c0,6.54-3.51,11.83-7.84,11.83s-7.84-5.29-7.84-11.83,3.83-.87,8.16-.87S253.38,36.31,253.38,52.81Z" />
                    </g>
                    <g id="Glass-5" data-name="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="260.99 72.02 260.99 77.84 242.63 77.84 230.09 62.86 230.09 35.1 260.99 72.02" />
                        <polygon class="cls-3"
                            points="260.99 57.77 260.99 66.83 232.09 32.28 239.66 32.28 260.99 57.77" />
                        <polygon class="cls-3" points="260.99 32.28 260.99 37.37 256.73 32.28 260.99 32.28" />
                    </g>
                </g>
            </g>
            <g id="Pic_Y" data-name="Pic Y">
                <g id="Frame_Y" data-name="Frame Y">
                    <polyline class="cls-16" points="323.36 26.42 338.81 11.37 354.25 26.42" />
                    <circle class="cls-17" cx="338.81" cy="13.74" r="1.4" />
                    <rect class="cls-18" x="317.23" y="25.74" width="43.15" height="58.58" />
                    <rect class="cls-19" x="323.36" y="32.26" width="30.89" height="45.56" />
                    <g id="Rocket">
                        <path class="cls-42"
                            d="M349.62,37.06s1.94,4.31-1.84,12.37l-.2.41c.23-.84-1-2.25-2.93-3.24s-3.79-1.22-4.34-.53l.23-.41C345,37.94,349.62,37.06,349.62,37.06Z" />
                        <g id="Fin_Left" data-name="Fin Left">
                            <polygon class="cls-34"
                                points="337.45 62.05 334.54 70.88 338.02 63.74 341.6 55.1 337.45 62.05" />
                            <polygon class="cls-46"
                                points="337.45 62.05 334.54 70.88 338.02 63.74 341.6 55.1 337.45 62.05" />
                        </g>
                        <path class="cls-47"
                            d="M335.56,64a2.29,2.29,0,0,1,.46.3,1.53,1.53,0,0,1,.34.33c.1.15.15.28.11.38h0v0c-.13.25-.74.18-1.36-.14s-1-.79-.89-1h0s0,0,0,0C334.38,63.64,335,63.71,335.56,64Z" />
                        <g id="Booster">
                            <path class="cls-48"
                                d="M335.56,64l.11.06c.5.29.82.66.74.88h0v0c-.12.23-.69.17-1.27-.13s-.92-.7-.84-.93c0,0,0,0,0,0h0c0-.08.15-.12.29-.13a1.76,1.76,0,0,1,.76.18l.07,0,.05,0Z" />
                            <path class="cls-49"
                                d="M335.11,63.34a0,0,0,0,0,0,0h0l-.59,1.13,1.37.72.59-1.14h0l0,0c.09-.18-.15-.48-.52-.68S335.2,63.17,335.11,63.34Z" />
                            <ellipse class="cls-22" cx="335.19" cy="64.86" rx="0.36" ry="0.77"
                                transform="translate(122.76 332.12) rotate(-62.47)" />
                        </g>
                        <path id="Stage" class="cls-50"
                            d="M344.65,46.6c1.91,1,3.16,2.4,2.93,3.24-.08.17-.16.34-.25.51-3.89,7.7-10.87,14.7-10.87,14.7v0h0c0-.1,0-.23-.11-.38a1.53,1.53,0,0,0-.34-.33,1.8,1.8,0,0,0-.35-.24l-.11-.06-.08,0-.05,0-.07,0c-.52-.23-1-.27-1.14-.08.12-.6,1.88-10,5.83-17.3l.26-.48C340.86,45.38,342.74,45.6,344.65,46.6Z" />
                        <path id="Band" class="cls-51"
                            d="M344.65,46.6c1.91,1,3.16,2.4,2.93,3.24a.78.78,0,0,1-.05.14h0l-.21.4s0,0,0,0a1.21,1.21,0,0,0,.05-.18V50s0,0,0,0a.87.87,0,0,0-.05-.22v0h0s0,0,0,0l0-.05,0,0a3.63,3.63,0,0,0-.62-.87l-.08-.08,0,0-.1-.09-.11-.11-.09-.08-.06-.05-.09-.08h0L346,48a1.55,1.55,0,0,0-.24-.19l-.1-.08-.13-.1-.27-.17a.41.41,0,0,0-.11-.07l-.06,0-.16-.1-.14-.08-.12-.07-.22-.11-.2-.11-.14-.07-.18-.08-.16-.07-.17-.07-.31-.12-.16-.06-.12,0-.2-.07-.14,0-.17,0-.13,0-.09,0-.12,0h0l-.14,0a3.79,3.79,0,0,0-.64-.07h-.46a.76.76,0,0,0-.16,0h-.15l-.13,0-.08,0a.05.05,0,0,1,0,0l-.1.07,0,0,0,0a.76.76,0,0,0-.11.14l0,.06.23-.46h0a.22.22,0,0,1,.05-.08C340.86,45.38,342.74,45.6,344.65,46.6Z" />
                        <path id="HL" class="cls-52"
                            d="M349.67,37.1s.9,3.77-3,11.78a93.3,93.3,0,0,1-10.33,15.77,1.53,1.53,0,0,0-.34-.33,119.52,119.52,0,0,0,9.39-15.65,52.3,52.3,0,0,0,4.2-11.54Z" />
                        <path id="SH" class="cls-53"
                            d="M349.62,37.06c-.11,0-3.82,1.46-8.1,9.1a87.49,87.49,0,0,0-6.92,17.59c-.14,0-.25,0-.29.13h0s0,0,0,0l-.07,0s1.88-10.51,6.33-18.22S349.5,37.08,349.62,37.06Z" />
                        <g id="SEG">
                            <polygon class="cls-22"
                                points="342.49 50.1 342.36 49.68 342.54 49.36 342.95 49.61 342.8 49.83 343 49.97 343.27 49.54 342.94 49.3 342.79 48.86 343.09 48.3 343.52 48.18 343.98 48.43 344.13 48.87 343.95 49.19 343.54 48.94 343.69 48.72 343.49 48.57 343.23 48.99 343.56 49.24 343.71 49.67 343.4 50.25 342.98 50.36 342.49 50.1" />
                            <path class="cls-3"
                                d="M343.5,48.23l.43.22.15.4-.13.26-.33-.17.11-.2,0-.07-.06,0-.19-.1-.07,0,0,.07-.21.4,0,.06.05,0,.3.19.14.4-.28.54-.39.12-.46-.24-.12-.38.13-.26.33.17-.11.2,0,.06.06,0,.19.1.07,0,0-.07.22-.41,0-.06-.06,0-.29-.18-.15-.4.28-.54.39-.11m0-.08-.45.13-.31.6.17.45.31.19-.21.42-.19-.1.14-.26-.46-.24-.18.35.14.44.51.27.45-.14.31-.6-.16-.45-.32-.2.21-.41.19.1-.14.27.46.24.18-.36L344,48.4l-.48-.25Z" />
                            <polygon class="cls-22"
                                points="340.75 52.76 341.8 50.82 342.86 51.42 342.65 51.74 342.05 51.39 341.8 51.78 342.41 52.13 342.2 52.46 341.66 52.13 341.35 52.64 342.03 53.03 341.84 53.33 340.75 52.76" />
                            <path class="cls-3"
                                d="M341.8,50.91l1,.51-.13.24-.58-.31-.07,0,0,.06-.2.38,0,.06.06,0,.53.27-.13.25-.52-.28-.07,0,0,.06-.26.49,0,.07.06,0,.6.31-.13.25-1-.52,1-1.85m0-.1-1,2,1.12.59.2-.38-.66-.34.25-.49.59.3.2-.37-.59-.31.19-.37.65.34.2-.38-1.11-.57Z" />
                            <polygon class="cls-22"
                                points="339.57 55.71 339.42 55.28 340.16 53.9 340.59 53.79 341.07 54.05 341.21 54.48 340.98 54.91 340.57 54.66 340.78 54.33 340.55 54.17 339.86 55.43 340.08 55.59 340.28 55.28 340.15 55.17 340.37 54.85 340.89 55.16 340.48 55.86 340.07 55.97 339.57 55.71" />
                            <path class="cls-3"
                                d="M340.57,53.83l.46.24.14.39-.19.37-.33-.17.16-.31,0-.06-.07,0-.21-.11-.07,0,0,.06-.64,1.24,0,.07.07,0,.21.11.06,0,0-.06.15-.29,0-.06-.06,0-.05,0,.12-.25.44.23-.34.66-.39.11-.45-.23-.15-.4.7-1.36.4-.11m0-.08-.46.13-.73,1.41.17.46.5.26.45-.13.39-.75-.57-.3-.19.38.11.06-.15.29-.21-.11.65-1.24.21.11-.2.37.46.24.24-.46-.16-.45-.51-.27Z" />
                        </g>
                        <g id="Porthole">
                            <circle class="cls-54" cx="346.52" cy="43.07" r="1.62" />
                            <circle class="cls-55" cx="346.5" cy="42.95" r="1.56" />
                            <path class="cls-42"
                                d="M347,41.89a1.2,1.2,0,0,1,.62.81,1.15,1.15,0,0,1-.11.81,1.12,1.12,0,0,1-.32.39,1.18,1.18,0,0,1-1.3.12A1.2,1.2,0,0,1,347,41.89Z" />
                            <path class="cls-34"
                                d="M346.93,41.84a1.52,1.52,0,0,0-.22,2.26A1.13,1.13,0,0,1,346,44a1.19,1.19,0,0,1-.51-1.6A1.17,1.17,0,0,1,346.93,41.84Z" />
                            <path class="cls-56"
                                d="M347.06,41.89a1.18,1.18,0,0,1,.5,1.59,1.19,1.19,0,0,1-.85.62,1.52,1.52,0,0,1,.22-2.26Z" />
                        </g>
                        <polygon id="Fin_Top" data-name="Fin Top" class="cls-57"
                            points="335.17 60.34 328.5 67.21 332.52 60.35 338.16 52.78 335.17 60.34" />
                        <polygon id="Fin_Right" data-name="Fin Right" class="cls-58"
                            points="339.78 58.98 339.55 68.8 342.08 61.25 343.83 51.9 339.78 58.98" />
                        <g id="Flames">
                            <path class="cls-59"
                                d="M328.12,78.94c-1.93-.92,1.11-10.38,2-12.31a3.88,3.88,0,1,1,7,3.33C336.24,71.9,330.06,79.86,328.12,78.94Z" />
                            <path class="cls-60"
                                d="M335,65.44a2.19,2.19,0,0,1,.63,3c-.61,1.17-4.92,7.55-5.87,7.06s1.81-7.69,2.42-8.85A2.18,2.18,0,0,1,335,65.44Z" />
                            <path class="cls-61"
                                d="M334.84,65.66a1.62,1.62,0,0,1,.51,2.22c-.44.85-3.84,5.94-4.56,5.56s1.5-6.08,1.94-6.92A1.63,1.63,0,0,1,334.84,65.66Z" />
                            <path class="cls-3"
                                d="M334.56,66.21a.79.79,0,0,1,.19,1.08c-.23.43-1.92,3-2.25,2.86s.83-3.05,1.05-3.48A.79.79,0,0,1,334.56,66.21Z" />
                        </g>
                    </g>
                    <g id="Glass-6" data-name="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="354.25 72 354.25 77.81 335.89 77.81 323.36 62.84 323.36 35.08 354.25 72" />
                        <polygon class="cls-3"
                            points="354.25 57.74 354.25 66.81 325.35 32.26 332.93 32.26 354.25 57.74" />
                        <polygon class="cls-3" points="354.25 32.26 354.25 37.34 349.99 32.26 354.25 32.26" />
                    </g>
                </g>
            </g>
            <g id="Pic_O" data-name="Pic O">
                <g id="Frame_O" data-name="Frame O">
                    <polyline class="cls-16" points="371.94 26.42 387.39 11.37 402.83 26.42" />
                    <circle class="cls-17" cx="387.39" cy="13.74" r="1.4" />
                    <rect class="cls-18" x="365.81" y="25.74" width="43.15" height="58.58" />
                    <rect class="cls-19" x="371.94" y="32.26" width="30.89" height="45.56" />
                    <g id="Boat1">
                        <g id="Sail">
                            <polygon class="cls-62"
                                points="390.85 60.83 390.14 60.83 390.39 39.32 390.59 39.32 390.85 60.83" />
                            <polygon class="cls-3" points="391.02 40.36 399.35 56.69 391.02 56.69 391.02 40.36" />
                            <polygon class="cls-3" points="389.94 40.76 376.52 56.69 389.94 56.69 389.94 40.76" />
                        </g>
                        <g id="Boat">
                            <path class="cls-3"
                                d="M399.77,61.42l-.1.8v.1l-.1.8v.1l-.1.77v.09l-.09.77v.09l-.1.77v.09l0,.12s-17.15.73-19.88,0A5.33,5.33,0,0,1,377,64.63a.63.63,0,0,1-.11-.12,5.19,5.19,0,0,1-.67-.83.75.75,0,0,1-.07-.12,5,5,0,0,1-.42-.79l-.06-.12a6.58,6.58,0,0,1-.27-.78.56.56,0,0,1,0-.12c-.08-.28-.14-.55-.19-.8a.5.5,0,0,0,0-.12c-.06-.37-.09-.69-.11-.94a130.61,130.61,0,0,0,13,1.61A62.5,62.5,0,0,0,399.77,61.42Z" />
                            <path id="Boat_rim" data-name="Boat rim" class="cls-60"
                                d="M400.14,60.82l-.08.6a65.19,65.19,0,0,1-12,.08c-6.95-.5-12.21-1.41-13.1-1.57-.41-.13-.36-.62-.36-.62s5.91,1.07,13.45,1.61A62,62,0,0,0,400.14,60.82Z" />
                            <path id="Boards" class="cls-63"
                                d="M391.33,62.43c-3.89-.06-11.48-1-16.2-1.6a.5.5,0,0,1,0,.12c9.34,1.1,12.56,1.59,16.8,1.59,1.8,0,5.46-.14,7.71-.22v-.1C397.76,62.34,394.63,62.49,391.33,62.43Zm0,.9c-3.83-.06-11.26-1-16-1.58a.56.56,0,0,0,0,.12c9.16,1.08,12.36,1.56,16.57,1.56,1.77,0,5.35-.12,7.6-.21v-.1C397.64,63.24,394.56,63.39,391.33,63.33Zm0,.86c-3.75-.07-10.94-.93-15.68-1.54l.06.12c8.91,1,12.09,1.52,16.24,1.52,1.74,0,5.23-.12,7.49-.21V64C397.53,64.1,394.5,64.24,391.33,64.19Zm0,.85c-3.63-.06-10.47-.87-15.2-1.48a.75.75,0,0,0,.07.12c8.54,1,11.67,1.47,15.75,1.47,1.72,0,5.13-.12,7.39-.21v-.09C397.42,65,394.45,65.1,391.33,65Zm0,.86c-3.44-.06-9.78-.79-14.46-1.39a.63.63,0,0,0,.11.12c7.95,1,11,1.37,15,1.37,1.69,0,5-.12,7.28-.2v-.09C397.31,65.82,394.39,66,391.33,65.9Z" />
                        </g>
                        <g id="Fisherman">
                            <path class="cls-64"
                                d="M391.37,60.12a2.56,2.56,0,0,1,.51-1.46c.15-.11.69-.26.76-.31a5.15,5.15,0,0,1,1.88,0c.2.2.46.73.55.8s.28.68.41.9a3.66,3.66,0,0,1,.13,1.07h-3.83S391.45,60.37,391.37,60.12Z" />
                            <circle class="cls-65" cx="393" cy="57.9" r="0.95" />
                            <path class="cls-63"
                                d="M393.18,58l-.18.22-.39.14-.45-.36-.3.07.18.77s-.2.18.12.61.45.46,1,.25c.24-.08.26-.51.28-.7a2.31,2.31,0,0,0,0-.71,1.55,1.55,0,0,0-.19-.29Z" />
                            <g id="Hat">
                                <path class="cls-64"
                                    d="M392,57.58a1.64,1.64,0,0,1,1.07,0c.16.12.25.44.75.67a3.82,3.82,0,0,0,.55.25,1.18,1.18,0,0,0,.35-.07,1.79,1.79,0,0,1-.49-.61c-.16-.37-.33-1.39-.41-1.59s-.46-.28-.76-.26-1,.83-1.06,1-.24.28-.37.52S391.93,57.54,392,57.58Z" />
                                <path class="cls-66"
                                    d="M391.59,57.55a5.11,5.11,0,0,0-.07-.58s.09.12.88.21a4.18,4.18,0,0,1,1.19.26c.13.11.13.27.41.46a1.06,1.06,0,0,0,.6.2l.25,0v.44a3.91,3.91,0,0,1-.46,0,3.75,3.75,0,0,1-1-.6,1.09,1.09,0,0,0-.63-.27,5.46,5.46,0,0,0-.7-.07Z" />
                            </g>
                            <polygon class="cls-67" points="394.33 61.12 394.05 59.68 393.81 61.09 394.33 61.12" />
                            <polygon class="cls-67" points="392.29 61.12 392.03 59.75 391.78 61.16 392.29 61.12" />
                        </g>
                    </g>
                    <g id="Glass-7" data-name="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="402.83 72 402.83 77.81 384.47 77.81 371.94 62.84 371.94 35.08 402.83 72" />
                        <polygon class="cls-3"
                            points="402.83 57.74 402.83 66.81 373.93 32.26 381.51 32.26 402.83 57.74" />
                        <polygon class="cls-3" points="402.83 32.26 402.83 37.34 398.57 32.26 402.83 32.26" />
                    </g>
                </g>
            </g>
            <g id="Pic_U" data-name="Pic U">
                <g id="Frame_U" data-name="Frame U">
                    <polyline class="cls-16" points="419.8 26.42 435.25 11.37 450.69 26.42" />
                    <circle class="cls-17" cx="435.25" cy="13.74" r="1.4" />
                    <rect class="cls-18" x="413.67" y="25.74" width="43.15" height="58.58" />
                    <rect class="cls-19" x="419.8" y="32.26" width="30.89" height="45.56" />
                    <g id="Dude-5" data-name="Dude">
                        <path class="cls-68"
                            d="M428.1,61.34H444a4.45,4.45,0,0,1,4.45,4.45v2.74A7.51,7.51,0,0,1,440.91,76H425.55a1.9,1.9,0,0,1-1.9-1.9V65.78a4.45,4.45,0,0,1,4.45-4.45Z" />
                        <path class="cls-69"
                            d="M444.4,50.78c0,7-3.7,9.14-8.32,9.14s-8.41-2.16-8.41-9.14S431.41,39.3,436,39.3,444.4,43.8,444.4,50.78Z" />
                        <path class="cls-70"
                            d="M444.4,55.75c0,7-3.7,7.37-8.32,7.37s-8.41-.39-8.41-7.37,4.08-.92,8.71-.92S444.4,38.14,444.4,55.75Z" />
                    </g>
                    <g id="Glass-8" data-name="Glass" class="cls-25">
                        <polygon class="cls-3"
                            points="450.69 72 450.69 77.81 432.33 77.81 419.8 62.84 419.8 35.08 450.69 72" />
                        <polygon class="cls-3"
                            points="450.69 57.74 450.69 66.81 421.79 32.26 429.37 32.26 450.69 57.74" />
                        <polygon class="cls-3" points="450.69 32.26 450.69 37.34 446.43 32.26 450.69 32.26" />
                    </g>
                </g>
            </g>
            <g id="Smash_1" data-name="Smash 1">
                <polygon class="cls-6" points="51.4 54.97 33.83 57.42 33.83 46.02 37.03 43.93 45.03 46.8 51.4 54.97" />
                <polygon class="cls-6" points="72.35 59.2 77.04 76.8 66.3 68.66 71.84 59.15 72.35 59.2" />
                <polygon class="cls-6" points="70.21 76.32 70.21 79.32 48.23 79.32 61.93 65.69 70.21 76.32" />
                <polygon class="cls-6" points="41.93 89.64 38.73 91.73 38.73 88.49 41.93 89.64" />
                <polygon class="cls-6" points="60.3 26.68 53.31 32.51 47.14 28.2 60.3 26.68" />
                <polygon class="cls-6"
                    points="74.97 40.45 74.97 44.2 58.02 32.41 67.74 27.42 67.79 27.42 74.97 40.45" />
                <polygon class="cls-6" points="87.51 44.88 84.83 57.63 82 43.72 87.51 44.88" />
                <polygon class="cls-6" points="56.82 65.28 41.3 76.8 32.48 75.51 35.03 58.04 52.77 58.14 56.82 65.28" />
                <polygon class="cls-6" points="65.14 101.5 53.24 100.94 48.5 91.73 65.14 101.5" />
                <polygon class="cls-6"
                    points="50.09 32.41 39.51 39.33 35.69 41.83 32.48 40.68 32.48 27.42 44.45 27.42 50.09 32.41" />
                <polygon class="cls-6"
                    points="69.96 44.89 69.96 51.7 68.44 51.91 50.27 45.39 46.09 40.02 56.67 33.1 69.96 44.89" />
                <polygon class="cls-6" points="69.03 54.23 59.73 64.56 53.72 55.94 67.79 53.74 69.03 54.23" />
                <polygon class="cls-6" points="28.03 60.31 20.03 57.45 23.85 54.95 28.03 60.31" />
            </g>
            <g id="Smash_2" data-name="Smash 2">
                <polygon class="cls-6"
                    points="198.32 54.52 180.75 56.97 180.75 45.57 183.95 43.48 191.95 46.35 198.32 54.52" />
                <polygon class="cls-6" points="219.27 58.75 223.97 76.34 213.22 68.21 218.76 58.7 219.27 58.75" />
                <polygon class="cls-6" points="217.13 75.87 217.13 78.87 195.15 78.87 208.85 65.24 217.13 75.87" />
                <polygon class="cls-6" points="188.85 89.19 185.65 91.28 185.65 88.04 188.85 89.19" />
                <polygon class="cls-6" points="207.22 26.23 200.23 32.06 194.06 27.75 207.22 26.23" />
                <polygon class="cls-6"
                    points="221.89 40 221.89 43.75 204.94 31.96 214.66 26.97 214.71 26.97 221.89 40" />
                <polygon class="cls-6" points="234.43 44.43 231.75 57.18 228.93 43.27 234.43 44.43" />
                <polygon class="cls-6"
                    points="203.74 64.83 188.22 76.34 179.41 75.06 181.95 57.59 199.69 57.69 203.74 64.83" />
                <polygon class="cls-6" points="212.07 101.05 200.16 100.49 195.42 91.28 212.07 101.05" />
                <polygon class="cls-6"
                    points="197.01 31.96 186.43 38.88 182.61 41.38 179.41 40.23 179.41 26.97 191.38 26.97 197.01 31.96" />
                <polygon class="cls-6"
                    points="216.88 44.44 216.88 51.24 215.36 51.45 197.19 44.94 193.01 39.56 203.59 32.65 216.88 44.44" />
                <polygon class="cls-6" points="215.95 53.78 206.65 64.11 200.64 55.48 214.71 53.29 215.95 53.78" />
                <polygon class="cls-6" points="174.95 59.86 166.95 56.99 170.77 54.49 174.95 59.86" />
            </g>
            <g id="Smash_3" data-name="Smash 3">
                <polygon class="cls-6"
                    points="339.13 51.19 321.56 53.64 321.56 42.24 324.76 40.15 332.76 43.02 339.13 51.19" />
                <polygon class="cls-6" points="360.08 55.42 364.78 73.02 354.04 64.88 359.57 55.37 360.08 55.42" />
                <polygon class="cls-6" points="357.94 72.54 357.94 75.54 335.96 75.54 349.66 61.91 357.94 72.54" />
                <polygon class="cls-6" points="329.66 85.86 326.46 87.95 326.46 84.72 329.66 85.86" />
                <polygon class="cls-6" points="348.04 22.9 341.04 28.74 334.87 24.43 348.04 22.9" />
                <polygon class="cls-6"
                    points="362.7 36.68 362.7 40.43 345.76 28.64 355.48 23.65 355.53 23.65 362.7 36.68" />
                <polygon class="cls-6" points="375.25 41.1 372.57 53.85 369.74 39.94 375.25 41.1" />
                <polygon class="cls-6"
                    points="344.55 61.5 329.04 73.02 320.22 71.74 322.76 54.26 340.5 54.37 344.55 61.5" />
                <polygon class="cls-6" points="352.88 97.73 340.98 97.16 336.23 87.95 352.88 97.73" />
                <polygon class="cls-6"
                    points="337.82 28.64 327.24 35.56 323.42 38.06 320.22 36.91 320.22 23.65 332.19 23.65 337.82 28.64" />
                <polygon class="cls-6"
                    points="357.69 41.11 357.69 47.92 356.17 48.13 338 41.61 333.82 36.24 344.4 29.32 357.69 41.11" />
                <polygon class="cls-6" points="356.76 50.46 347.46 60.78 341.45 52.16 355.52 49.96 356.76 50.46" />
                <polygon class="cls-6" points="315.76 56.54 307.76 53.67 311.58 51.17 315.76 56.54" />
            </g>
            <g id="Smash_4" data-name="Smash 4">
                <polygon class="cls-6"
                    points="435.88 51.19 418.31 53.64 418.31 42.24 421.51 40.15 429.51 43.02 435.88 51.19" />
                <polygon class="cls-6" points="456.83 55.42 461.53 73.02 450.79 64.88 456.32 55.37 456.83 55.42" />
                <polygon class="cls-6" points="454.69 72.54 454.69 75.54 432.71 75.54 446.41 61.91 454.69 72.54" />
                <polygon class="cls-6" points="426.41 85.86 423.21 87.95 423.21 84.72 426.41 85.86" />
                <polygon class="cls-6" points="444.79 22.9 437.79 28.74 431.63 24.43 444.79 22.9" />
                <polygon class="cls-6"
                    points="459.46 36.68 459.46 40.43 442.51 28.64 452.23 23.65 452.28 23.65 459.46 36.68" />
                <polygon class="cls-6" points="472 41.1 469.32 53.85 466.49 39.94 472 41.1" />
                <polygon class="cls-6"
                    points="441.31 61.5 425.79 73.02 416.97 71.74 419.51 54.26 437.25 54.37 441.31 61.5" />
                <polygon class="cls-6" points="449.63 97.73 437.73 97.16 432.98 87.95 449.63 97.73" />
                <polygon class="cls-6"
                    points="434.57 28.64 423.99 35.56 420.17 38.06 416.97 36.91 416.97 23.65 428.94 23.65 434.57 28.64" />
                <polygon class="cls-6"
                    points="454.44 41.11 454.44 47.92 452.92 48.13 434.75 41.61 430.57 36.24 441.15 29.32 454.44 41.11" />
                <polygon class="cls-6" points="453.51 50.46 444.21 60.78 438.21 52.16 452.27 49.96 453.51 50.46" />
                <polygon class="cls-6" points="412.51 56.54 404.51 53.67 408.33 51.17 412.51 56.54" />
            </g>
            <path id="Window_Smash" data-name="Window Smash" class="cls-6"
                d="M611.61,66.55,573.5,69.18V57l6.94-2.24,17.35,3.07ZM656,71l-12,10.2L667.23,90,657.06,71.09Zm-21.51,7L604.73,92.66H652.4V89.44Zm-50.31,24.44V106l6.94-2.25Zm18.24-64.63,13.38,4.61,15.17-6.25Zm44.8-.84h-.11L626,42.37,662.74,55V51ZM678,54.49l6.14,14.91,5.81-13.67ZM614.58,70l-38.48-.11-5.51,18.74L589.71,90l33.66-12.34Zm-9.26,36,10.29,9.87,25.81.6ZM596.55,37h-26V51.24l6.94,1.23,8.28-2.68,23-7.42ZM623,43.1l-22.95,7.42,9.07,5.76,39.41,7,3.3-.23v-7.3Zm24.11,22.13-30.5,2.36,13,9.24,20.16-11.07Zm-95.29,1.3-8.29,2.68,17.35,3.07Zm172.5,11,17.36,3.07,6.94-2.24V66.14l-38.11,2.63ZM666.21,64.29l12-10.2-23.29-8.72L665.1,64.23Zm21.51-7,29.71-14.61H669.76v3.22ZM738,32.83V29.36l-6.94,2.24ZM719.78,97.47l-13.37-4.62L691.24,99.1ZM675,98.3h.11L696.18,93,659.42,80.31v4ZM644.17,80.83,638,65.92l-5.81,13.67Zm63.41-15.46,38.48.11,5.51-18.74-19.12-1.37L698.79,57.71Zm9.26-36-10.29-9.88-25.82-.6Zm8.77,68.94h26V84.08l-6.94-1.23-8.28,2.68L713.4,93Zm-26.49-6.08,23-7.42L713,79l-39.41-7-3.3.23v7.3ZM675,70.09l30.51-2.36-13-9.24L672.32,69.56Zm95.3-1.3,8.29-2.68L761.23,63Z" />
            <g id="Waves">
                <circle class="cls-71" cx="401.49" cy="204.35" r="26.69" />
                <circle class="cls-71" cx="401.49" cy="204.35" r="40.59" />
                <circle class="cls-71" cx="401.49" cy="204.35" r="54.49" />
                <circle class="cls-71" cx="401.49" cy="204.35" r="69.78" />
            </g>
            <ellipse class="cls-72" cx="762.98" cy="270.62" rx="17.6" ry="5.56" />
            <g id="Cat-2" data-name="Cat">
                <path class="cls-20"
                    d="M776.55,258c-3.8-4.41-2.93-7.17-2.57-7.91a2.22,2.22,0,0,1,2.1-1.36,1.84,1.84,0,0,0,.15-3.67,5.91,5.91,0,0,0-5.56,3.44c-1.61,3.33-.45,7.78,3.1,11.9a3.37,3.37,0,0,1,.92,3.55,4,4,0,0,1-3.58,2.1h0a3.49,3.49,0,0,1-3.06-1.75,9.75,9.75,0,0,0,.35-2.55v-5.3a9.92,9.92,0,0,0-4.67-8.38,6.73,6.73,0,0,0-.92-11.53l-1.57-6.39-2.4,5.68h-2.78l-1.37-5.54-3,7.05a6.73,6.73,0,0,0,.33,10.73,9.92,9.92,0,0,0-4.67,8.38v5.3a9.93,9.93,0,0,0,9.9,9.9h1.22a9.91,9.91,0,0,0,7.77-3.79,7,7,0,0,0,4.84,1.86h0a7.62,7.62,0,0,0,6.9-4.25C779.12,263.07,778.59,260.34,776.55,258Z" />
                <circle class="cls-21" cx="759.81" cy="242.78" r="1.48" />
                <circle class="cls-21" cx="753.68" cy="242.78" r="1.48" />
                <path class="cls-22"
                    d="M757.05,245.71c-.12.12-.06.43-.21.42s-.06-.32-.15-.41-.38-.29-.17-.5a.53.53,0,0,1,.75,0C757.48,245.43,757.26,245.5,757.05,245.71Z" />
                <path class="cls-23"
                    d="M760.19,242.78a3.3,3.3,0,0,1-.28,1.29,3.4,3.4,0,0,1-.27-1.29,3.33,3.33,0,0,1,.27-1.29A3.23,3.23,0,0,1,760.19,242.78Z" />
                <path class="cls-23" d="M753.84,242.78a.68.68,0,1,1-.56,0,.68.68,0,1,1,.56,0Z" />
                <polygon class="cls-22"
                    points="760.88 246.44 758.36 246.03 760.86 246.03 760.86 245.92 757.67 245.92 757.67 246.08 760.71 247.04 760.74 246.94 758.54 246.21 760.86 246.55 760.88 246.44" />
                <polygon class="cls-22"
                    points="752.8 246.44 755.33 246.03 752.82 246.03 752.82 245.92 756.01 245.92 756.02 246.08 752.98 247.04 752.94 246.94 755.14 246.21 752.82 246.55 752.8 246.44" />
                <path class="cls-24" d="M754.41,232.76c-.29.5-1.61,4-1.61,4l1.41-.71Z" />
                <path class="cls-24" d="M760.72,232.23c.27.5,1.48,4,1.48,4l-1.3-.7Z" />
            </g>
            <g id="Drummer">
                <g id="Arm_L" data-name="Arm L">
                    <path id="Arm" class="cls-27"
                        d="M373.59,94s-3.74,1.8-4.83,2.38c-1.86,1-.39,3.77-.39,3.77l-6.61,18.14a2.7,2.7,0,0,0,.12,2,1.68,1.68,0,0,0,1.19.92l17.85,4.83,1.92-6.82L369,115.53l3.29-14.27h0s2.43-.07,2.67-.94l.32-4C375.54,95.47,374.45,94.23,373.59,94Z" />
                    <rect class="cls-22" x="385.49" y="115.65" width="9.42" height="18.61"
                        transform="translate(163.79 466.44) rotate(-74.21)" />
                    <path id="Drumstick" class="cls-73"
                        d="M383.37,66.75s0,0,0,0a.83.83,0,0,0,.53-.68l.16-.85a.42.42,0,0,0-.26-.51l-.11,0a.42.42,0,0,0-.51.24l-.4.79a.86.86,0,0,0,0,.84l0,.06-11.43,31.8c-.1.28.19.64.65.8s.91,0,1-.24Z" />
                </g>
                <g id="Arm_R" data-name="Arm R">
                    <path id="Arm-2" data-name="Arm" class="cls-27"
                        d="M440.6,93.45s3.67,2,4.73,2.58c1.81,1.06.23,3.78.23,3.78l5.85,18.4a2.71,2.71,0,0,1-.2,2,1.66,1.66,0,0,1-1.23.87l-18,4.08-1.64-6.89,14-3.12-2.69-14.4h0s-2.42-.17-2.63-1l-.16-4C438.6,94.84,439.73,93.65,440.6,93.45Z" />
                    <rect class="cls-22" x="418.31" y="114.63" width="9.42" height="17.99"
                        transform="translate(400.84 563.78) rotate(-103.41)" />
                    <path id="Drumstick-2" data-name="Drumstick" class="cls-73"
                        d="M430.18,65.69v0a.85.85,0,0,1-.54-.68l-.17-.86a.44.44,0,0,1,.25-.51l.12,0a.44.44,0,0,1,.51.25l.4.77a.86.86,0,0,1,0,.85.13.13,0,0,1,0,.06l11.71,31.7c.1.28-.19.64-.65.8s-.91.06-1-.23Z" />
                </g>
                <g id="Torso">
                    <path class="cls-22"
                        d="M395.1,186l-5.74-51.66s-1.67-10.56-.21-13.1c1.93-3.37,9.34-5.49,11.58-5.61.91-.05,4.33,1.54,6.08,1.55a22.71,22.71,0,0,0,6.4-1.55s6.82,2.19,9.79,4.59,1.86,13.15,1.86,13.15l-5.46,52.72Z" />
                    <path id="Skull" class="cls-35"
                        d="M413,139.07c0-.09-.71-.9-.26-1.37,1.55-1.66,1-7,.65-8-.7-2.13-3-2.71-4.88-3.13a14.12,14.12,0,0,0-4.28.15c-2.42.41-4.45,3.14-4.23,7,.12,2.08,1.07,3.62,1.13,4.66s-.74.88-.32,1.06c.9.39,3.32,1.83,2.63,2.21-1,.55-.19,2.38-.19,2.38a.89.89,0,0,0,.65.63l.49.13,0-2.12.11,0,.28.07v2.11c.32.06.7.13,1.09.18v-2.15h.38l0,2.17q.32,0,.63,0l.46,0v-2.17h.37v2.14a6.69,6.69,0,0,0,1.07-.22v-2.22a.35.35,0,0,0,.11,0l.29-.09v2.22a4.34,4.34,0,0,0,.42-.15l.11,0c.48-.24.38-.22.38-.22s.79-2-.11-2.79S410.42,140.28,413,139.07Zm-8.1-.79-2.24.47c-.77,0-1.18-1.46-1.18-2.3v-1a1.46,1.46,0,0,1,1.39-1.52l2.57.51c.78.36.92.41.92,1.24v.74A2,2,0,0,1,404.91,138.28Zm1.81,2.21c-.05.29-.19.51-.32.49l-.15,0a.45.45,0,0,1-.29-.52l.2-.85c.11-.32.24-.53.37-.5l.12,0c.13,0,.13.08.14.4Zm.8.45-.16,0c-.13,0-.27-.2-.31-.49l-.08-1c0-.32,0-.37.14-.4l.12,0c.13,0,.27.18.37.5l.21.85A.46.46,0,0,1,407.52,140.94Zm1.43-2.66a2,2,0,0,1-1.47-1.83v-.74c0-.83.15-.88.93-1.24L411,134a1.46,1.46,0,0,1,1.39,1.52v1c0,.84-.41,2.3-1.18,2.3Z" />
                </g>
                <g id="Head">
                    <ellipse class="cls-27" cx="407.84" cy="105.8" rx="9.17" ry="11.86" />
                    <path class="cls-26"
                        d="M418.45,102.24c-1.82-5.23-4.65-10.38-10.38-10.38h0c-5.74,0-8.57,4.09-10.38,10.38l-1.07,19.1c0,5.43,4.17,16.9,4.17,16.9l3.94-3s-.45-15-.45-15.92,3.42-16.72,3.71-13.94,1.67,6.52,1.67,7.58.83,6.89.83,8.56,1,11.59.84,13.26c-.11,1.19.3,1.21,2.72,3.87,2.81-5.31,5.61-13.76,5.61-17.74Z" />
                </g>
            </g>
            <g id="Kit">
                <g id="Snare">
                    <g id="Snare_Stand" data-name="Snare Stand">
                        <g id="Tall_stand" data-name="Tall stand">
                            <rect class="cls-22" x="431.99" y="236.52" width="2.51" height="2.03"
                                transform="translate(571.63 711.85) rotate(-135)" />
                            <ellipse class="cls-22" cx="432.53" cy="238.26" rx="0.79" ry="1.25"
                                transform="translate(-41.79 375.63) rotate(-45)" />
                            <ellipse class="cls-74" cx="433.96" cy="236.82" rx="0.79" ry="1.25"
                                transform="translate(-40.35 376.22) rotate(-45)" />
                            <rect class="cls-22" x="479.9" y="236.52" width="2.51" height="2.03"
                                transform="translate(989.35 65.27) rotate(135)" />
                            <ellipse class="cls-22" cx="481.88" cy="238.26" rx="1.25" ry="0.79"
                                transform="translate(-27.33 410.52) rotate(-45)" />
                            <ellipse class="cls-74" cx="480.44" cy="236.82" rx="1.25" ry="0.79"
                                transform="translate(-26.74 409.08) rotate(-45)" />
                            <rect class="cls-75" x="445.06" y="208.55" width="1.14" height="33.19"
                                transform="translate(601.54 699.47) rotate(-135)" />
                            <rect class="cls-22" x="461.09" y="231.63" width="1.73" height="1.11"
                                transform="translate(963.75 356.71) rotate(167.25)" />
                            <ellipse class="cls-22" cx="462.07" cy="232.73" rx="0.86" ry="0.43"
                                transform="translate(-39.96 107.7) rotate(-12.75)" />
                            <ellipse class="cls-74" cx="461.83" cy="231.64" rx="0.86" ry="0.43"
                                transform="translate(-39.73 107.62) rotate(-12.75)" />
                            <rect class="cls-76" x="459.46" y="213.8" width="0.79" height="18.18"
                                transform="translate(957.54 338.81) rotate(167.25)" />
                            <rect class="cls-77" x="468.2" y="208.55" width="1.14" height="33.19"
                                transform="translate(-21.91 397.42) rotate(-45)" />
                            <rect class="cls-78" x="454.01" y="219.14" width="0.28" height="8.19"
                                transform="translate(933.14 59.95) rotate(135)" />
                            <rect class="cls-79" x="460.22" y="219.14" width="0.28" height="8.19"
                                transform="translate(292.69 -260.14) rotate(45)" />
                            <rect class="cls-80" x="456.63" y="171.09" width="1.14" height="55.14"
                                transform="translate(914.4 397.32) rotate(-180)" />
                        </g>
                    </g>
                    <path class="cls-81"
                        d="M434.74,185.36c1.9,2.44,11.23,4.3,22.46,4.3,11.56,0,21.1-2,22.61-4.52a1.09,1.09,0,0,0,.21-.64v-1.06c0-2.88-10.21-5.22-22.82-5.22s-22.82,2.34-22.82,5.22v1.22A1,1,0,0,0,434.74,185.36Z" />
                    <path class="cls-82"
                        d="M435.36,184.14c0,1.68,9.92,4.77,22.09,4.77s22.05-3.09,22.1-4.77h0V171.79h-44.2v12.35Z" />
                    <path class="cls-83"
                        d="M434.74,172.69c1.9,2.38,11.23,4.19,22.46,4.19,11.56,0,21.1-1.92,22.61-4.4a1.05,1.05,0,0,0,.21-.62v-1c0-2.81-10.21-5.08-22.82-5.08s-22.82,2.27-22.82,5.08V172A1,1,0,0,0,434.74,172.69Z" />
                    <ellipse class="cls-84" cx="457.2" cy="170.4" rx="21.7" ry="4.42" />
                    <rect class="cls-85" x="456.95" y="176.86" width="0.5" height="4.24"
                        transform="translate(914.4 357.96) rotate(180)" />
                    <rect class="cls-86" x="456.18" y="178.14" width="2.05" height="2.19"
                        transform="translate(914.4 358.47) rotate(180)" />
                    <polygon class="cls-87"
                        points="473.34 175.39 473.84 175.26 473.84 179.3 473.34 179.41 473.34 175.39" />
                    <rect class="cls-88" x="456.97" y="184.47" width="0.5" height="4.38" />
                    <rect class="cls-89" x="456.22" y="185.33" width="2.01" height="2.15" />
                    <polygon class="cls-90" points="440.67 175.3 440.18 175.21 440.1 179.26 440.6 179.4 440.67 175.3" />
                    <polygon class="cls-91"
                        points="441.05 177.06 439.63 176.7 439.63 178.25 441.05 178.58 441.05 177.06" />
                    <polygon class="cls-92"
                        points="472.86 177.04 474.32 176.67 474.32 178.27 472.86 178.61 472.86 177.04" />
                    <g id="Bracket">
                        <polygon class="cls-93"
                            points="473.82 186.89 473.32 187 473.32 183.15 473.82 183.01 473.82 186.89" />
                        <polygon class="cls-94"
                            points="472.67 183.97 474.31 183.56 474.31 185.35 472.67 185.74 472.67 183.97" />
                    </g>
                    <g id="Bracket-2" data-name="Bracket">
                        <polygon class="cls-95"
                            points="440.01 186.89 440.51 187 440.51 183.15 440.01 183.01 440.01 186.89" />
                        <polygon class="cls-96"
                            points="441.05 184.06 439.63 183.71 439.63 185.26 441.05 185.59 441.05 184.06" />
                    </g>
                </g>
                <g id="Hihat">
                    <g id="Hihat_stand" data-name="Hihat stand">
                        <rect class="cls-22" x="300.69" y="235.81" width="2.34" height="1.9"
                            transform="translate(347.89 617.63) rotate(-135)" />
                        <ellipse class="cls-22" cx="301.19" cy="237.43" rx="0.73" ry="1.17"
                            transform="translate(-79.67 282.52) rotate(-45)" />
                        <ellipse class="cls-74" cx="302.53" cy="236.09" rx="0.73" ry="1.17"
                            transform="translate(-78.33 283.07) rotate(-45)" />
                        <rect class="cls-22" x="345.45" y="235.81" width="2.34" height="1.9"
                            transform="translate(759.14 159.08) rotate(135)" />
                        <ellipse class="cls-22" cx="347.29" cy="237.43" rx="1.17" ry="0.73"
                            transform="translate(-66.17 315.12) rotate(-45)" />
                        <ellipse class="cls-74" cx="345.95" cy="236.09" rx="1.17" ry="0.73"
                            transform="translate(-65.61 313.77) rotate(-45)" />
                        <rect class="cls-97" x="312.9" y="209.68" width="1.07" height="31.01"
                            transform="translate(375.83 606.05) rotate(-135)" />
                        <rect class="cls-22" x="327.87" y="231.24" width="1.61" height="1.04"
                            transform="translate(700.4 385.28) rotate(167.25)" />
                        <ellipse class="cls-22" cx="328.8" cy="232.27" rx="0.81" ry="0.4"
                            transform="translate(-43.15 78.28) rotate(-12.75)" />
                        <ellipse class="cls-74" cx="328.57" cy="231.25" rx="0.81" ry="0.4"
                            transform="translate(-42.93 78.2) rotate(-12.75)" />
                        <rect class="cls-98" x="326.35" y="214.58" width="0.73" height="16.99"
                            transform="translate(694.6 368.56) rotate(167.25)" />
                        <rect class="cls-99" x="334.52" y="209.68" width="1.07" height="31.01"
                            transform="translate(-61.1 302.87) rotate(-45)" />
                        <rect class="cls-100" x="321.26" y="219.57" width="0.26" height="7.65"
                            transform="translate(706.62 154.1) rotate(135)" />
                        <rect class="cls-101" x="327.06" y="219.57" width="0.26" height="7.65"
                            transform="translate(253.8 -165.93) rotate(45)" />
                        <rect class="cls-102" x="323.71" y="160.93" width="1.07" height="65.26"
                            transform="translate(648.49 387.13) rotate(-180)" />
                    </g>
                    <g id="Hihat_top_cymbal" data-name="Hihat top cymbal">
                        <path class="cls-103"
                            d="M345.21,160.41c0-2.42-9.35-4.38-20.87-4.38s-20.87,2-20.87,4.38,9.34,5.34,20.87,5.34S345.21,162.83,345.21,160.41Z" />
                        <path class="cls-104"
                            d="M303.47,156.51c0,2.42,9.34,4.38,20.87,4.38s20.87-2,20.87-4.38-9.35-5.34-20.87-5.34S303.47,154.09,303.47,156.51Z" />
                        <rect class="cls-22" x="323.26" y="154.9" width="2.15" height="0.71"
                            transform="translate(648.68 310.51) rotate(-180)" />
                        <ellipse class="cls-22" cx="324.34" cy="155.61" rx="1.08" ry="0.27" />
                        <ellipse class="cls-74" cx="324.34" cy="154.9" rx="1.08" ry="0.27" />
                    </g>
                </g>
                <g id="FloorTom">
                    <path class="cls-105"
                        d="M327.82,217.29c1.91,2.09,11.24,3.68,22.47,3.68,11.55,0,21.1-1.68,22.6-3.87a.85.85,0,0,0,.22-.54v-.92c0-2.47-10.22-4.47-22.82-4.47s-22.83,2-22.83,4.47v1.05A.85.85,0,0,0,327.82,217.29Z" />
                    <path class="cls-106"
                        d="M328.19,215.91c.05,1.47,9.92,4.17,22.1,4.17s22-2.7,22.09-4.17h0V175.78H328.19v40.13Z" />
                    <path class="cls-107"
                        d="M327.82,175.71c1.91,1.29,11.24,2.27,22.47,2.27,11.55,0,21.1-1,22.6-2.38a.46.46,0,0,0,.22-.34v-.56c0-1.52-10.22-2.75-22.82-2.75s-22.83,1.23-22.83,2.75v.64C327.46,175.47,327.59,175.59,327.82,175.71Z" />
                    <ellipse class="cls-108" cx="350.29" cy="174.7" rx="21.7" ry="2.62" />
                    <rect class="cls-109" x="350.04" y="177.98" width="0.5" height="9.21"
                        transform="translate(700.57 365.17) rotate(180)" />
                    <rect class="cls-110" x="348.98" y="182.75" width="2.6" height="3.81"
                        transform="translate(700.57 369.3) rotate(180)" />
                    <polygon class="cls-111"
                        points="366.43 177.18 366.92 177.11 366.92 186.15 366.43 186.27 366.43 177.18" />
                    <polygon class="cls-112"
                        points="365.35 182.09 367.96 181.59 367.96 185.28 365.35 185.89 365.35 182.09" />
                    <polygon class="cls-113"
                        points="333.68 177.18 333.19 177.11 333.19 186.15 333.68 186.27 333.68 177.18" />
                    <polygon class="cls-114"
                        points="334.76 182.09 332.15 181.59 332.15 185.28 334.76 185.89 334.76 182.09" />
                    <rect class="cls-115" x="349.33" y="209.6" width="0.5" height="9.21" />
                    <rect class="cls-116" x="348.27" y="210.24" width="2.6" height="3.81" />
                    <polygon class="cls-117"
                        points="367.15 217.88 366.65 217.95 366.65 208.91 367.15 208.79 367.15 217.88" />
                    <polygon class="cls-118"
                        points="368.23 212.98 365.62 213.48 365.62 209.78 368.23 209.17 368.23 212.98" />
                    <polygon class="cls-119"
                        points="333.23 217.88 333.72 217.95 333.72 208.91 333.23 208.79 333.23 217.88" />
                    <polygon class="cls-120"
                        points="332.15 212.98 334.76 213.48 334.76 209.78 332.15 209.17 332.15 212.98" />
                    <g id="Foot_Left" data-name="Foot Left">
                        <rect class="cls-22" x="326.69" y="249.43" width="3.11" height="2.52"
                            transform="translate(116.03 -103.65) rotate(21.71)" />
                        <ellipse class="cls-22" cx="327.78" cy="251.86" rx="0.97" ry="1.55"
                            transform="translate(-27.48 463.2) rotate(-68.29)" />
                        <ellipse class="cls-74" cx="328.71" cy="249.52" rx="0.97" ry="1.55"
                            transform="translate(-24.72 462.59) rotate(-68.29)" />
                        <polygon class="cls-121"
                            points="337.23 195.27 337.23 230.22 328.18 249.45 329.06 249.85 338.16 230.48 338.19 230.48 338.19 195.27 337.23 195.27" />
                    </g>
                    <g id="Foot_Right" data-name="Foot Right">
                        <rect class="cls-22" x="376.89" y="241.89" width="3.11" height="2.52"
                            transform="translate(-67.92 187.48) rotate(-25.61)" />
                        <ellipse class="cls-22" cx="378.99" cy="244.29" rx="1.55" ry="0.97"
                            transform="translate(-68.36 187.83) rotate(-25.61)" />
                        <ellipse class="cls-74" cx="377.9" cy="242.01" rx="1.55" ry="0.97"
                            transform="translate(-67.48 187.14) rotate(-25.61)" />
                        <polygon class="cls-122"
                            points="370.68 193.78 370.68 224.69 378.19 241.7 377.47 242.06 369.91 224.92 369.88 224.92 369.88 193.78 370.68 193.78" />
                    </g>
                    <g id="Foot_Back" data-name="Foot Back">
                        <polygon class="cls-22"
                            points="340.11 230.63 342.49 231.19 342.67 228.96 340.29 228.4 340.11 230.63" />
                        <ellipse class="cls-22" cx="341.3" cy="230.91" rx="0.84" ry="1.24"
                            transform="translate(2.58 465.58) rotate(-68.79)" />
                        <ellipse class="cls-74" cx="341.48" cy="228.68" rx="0.84" ry="1.24"
                            transform="translate(4.77 464.33) rotate(-68.79)" />
                        <polygon class="cls-123"
                            points="341.19 228.47 341.81 228.63 342.67 220.7 341.94 220.48 341.19 228.47" />
                    </g>
                </g>
                <g id="Kick">
                    <circle class="cls-124" cx="407.57" cy="207.36" r="34.64" />
                    <path class="cls-125"
                        d="M443.41,210l-3.66-11.82a33.47,33.47,0,0,0-64.18-.67c-.07.22-.13.44-.19.67h0l-.07.29c0,.12-.07.24-.1.37L371,212.39l5,6a33.46,33.46,0,0,0,63.2,0Z" />
                    <circle class="cls-126" cx="407.57" cy="217.98" r="36.72" />
                    <circle class="cls-127" cx="407.57" cy="216.62" r="34.27" /><text class="cls-128"
                        transform="translate(393.58 210.69)">SEG</text>
                    <polygon class="cls-129"
                        points="383.91 191.58 383.31 192.27 384.04 181.65 384.51 181.1 383.91 191.58" />
                    <polygon class="cls-130"
                        points="385.33 185.66 382.47 188.97 382.71 186.38 385.41 183.25 385.33 185.66" />
                    <polygon class="cls-131"
                        points="430.79 181.79 430.19 181.1 430.91 191.72 431.39 192.27 430.79 181.79" />
                    <polygon class="cls-132"
                        points="432.2 187.7 429.35 184.4 429.59 186.98 432.29 190.11 432.2 187.7" />
                </g>
                <g id="TomTom">
                    <ellipse class="cls-133" cx="383.78" cy="152.39" rx="20.11" ry="7.26" />
                    <path class="cls-134"
                        d="M403.26,153.21c-.05-3.87-8.75-7-19.48-7s-19.43,3.13-19.47,7h0v21h38.95v-21Z" />
                    <path class="cls-135"
                        d="M403.58,171.43c-1.68-3.4-9.9-6-19.8-6-10.18,0-18.59,2.73-19.92,6.28a2.21,2.21,0,0,0-.19.88v1.48c0,4,9,7.26,20.11,7.26s20.12-3.25,20.12-7.26V172.4A1.73,1.73,0,0,0,403.58,171.43Z" />
                    <ellipse class="cls-136" cx="383.78" cy="174.09" rx="19.13" ry="6.9" />
                    <rect class="cls-137" x="372.83" y="147.45" width="0.44" height="19.05" />
                    <rect class="cls-138" x="371.9" y="154.69" width="2.3" height="4.57" />
                    <rect class="cls-139" x="394.3" y="147.45" width="0.44" height="19.05" />
                    <rect class="cls-140" x="393.37" y="154.69" width="2.3" height="4.57" />
                </g>
                <g id="TomTom_Big" data-name="TomTom Big">
                    <ellipse class="cls-141" cx="435.5" cy="151.91" rx="22.82" ry="7.99" />
                    <path class="cls-142"
                        d="M457.6,152.8c-.05-4.26-9.92-7.71-22.1-7.71s-22,3.45-22.09,7.71h0V176h44.2V152.8Z" />
                    <path class="cls-143"
                        d="M458,172.86c-1.9-3.74-11.23-6.58-22.46-6.58-11.56,0-21.1,3-22.61,6.91a2.53,2.53,0,0,0-.21,1v1.62c0,4.42,10.22,8,22.82,8s22.82-3.58,22.82-8v-1.86A2,2,0,0,0,458,172.86Z" />
                    <ellipse class="cls-144" cx="435.5" cy="175.79" rx="21.7" ry="7.6" />
                    <rect class="cls-145" x="423.07" y="146.47" width="0.5" height="20.98" />
                    <rect class="cls-146" x="422.02" y="154.44" width="2.6" height="5.03" />
                    <rect class="cls-147" x="447.43" y="146.47" width="0.5" height="20.98" />
                    <rect class="cls-148" x="446.38" y="154.44" width="2.6" height="5.03" />
                </g>
                <g id="Ride">
                    <g id="Tall_stand-2" data-name="Tall stand">
                        <rect class="cls-22" x="500.12" y="243.2" width="2.51" height="2.03"
                            transform="translate(-25.83 426.06) rotate(-45)" />
                        <ellipse class="cls-22" cx="502.1" cy="244.93" rx="1.25" ry="0.79"
                            transform="translate(-26.13 426.78) rotate(-45)" />
                        <ellipse class="cls-74" cx="500.66" cy="243.49" rx="1.25" ry="0.79"
                            transform="translate(-25.54 425.34) rotate(-45)" />
                        <rect class="cls-22" x="452.21" y="243.2" width="2.51" height="2.03"
                            transform="translate(305.5 -249.12) rotate(45)" />
                        <ellipse class="cls-22" cx="452.75" cy="244.93" rx="0.79" ry="1.25"
                            transform="translate(-40.59 391.88) rotate(-45)" />
                        <ellipse class="cls-74" cx="454.19" cy="243.49" rx="0.79" ry="1.25"
                            transform="translate(-39.15 392.48) rotate(-45)" />
                        <rect class="cls-149" x="475.34" y="124.69" width="1.14" height="33.19"
                            transform="translate(39.48 377.9) rotate(-45)" />
                        <rect class="cls-150" x="488.42" y="215.23" width="1.14" height="33.19"
                            transform="translate(-20.7 413.67) rotate(-45)" />
                        <rect class="cls-22" x="471.81" y="238.3" width="1.73" height="1.11"
                            transform="translate(64.36 -98.41) rotate(12.75)" />
                        <ellipse class="cls-22" cx="472.55" cy="239.4" rx="0.43" ry="0.86"
                            transform="translate(134.78 647.48) rotate(-77.25)" />
                        <ellipse class="cls-74" cx="472.8" cy="238.32" rx="0.43" ry="0.86"
                            transform="translate(136.03 646.87) rotate(-77.25)" />
                        <rect class="cls-151" x="474.38" y="220.47" width="0.79" height="18.18"
                            transform="translate(62.36 -99.11) rotate(12.75)" />
                        <rect class="cls-152" x="465.28" y="215.23" width="1.14" height="33.19"
                            transform="translate(631.34 725.16) rotate(-135)" />
                        <rect class="cls-153" x="480.33" y="225.81" width="0.28" height="8.19"
                            transform="translate(303.3 -272.41) rotate(45)" />
                        <rect class="cls-154" x="474.12" y="225.81" width="0.28" height="8.19"
                            transform="translate(972.19 57.12) rotate(135)" />
                        <rect class="cls-155" x="476.85" y="142.83" width="1.14" height="90.07" />
                    </g>
                    <g id="Ride_cymbal" data-name="Ride cymbal">
                        <path class="cls-156"
                            d="M493.38,131.94c0,3.42-13.2,6.19-29.49,6.19s-29.5-2.77-29.5-6.19,13.21-7.55,29.5-7.55S493.38,128.52,493.38,131.94Z" />
                        <rect class="cls-22" x="462.37" y="127.39" width="3.04" height="1" />
                        <ellipse class="cls-22" cx="463.89" cy="128.39" rx="1.52" ry="0.39" />
                        <ellipse class="cls-74" cx="463.89" cy="127.39" rx="1.52" ry="0.39" />
                    </g>
                </g>
                <g id="Crash">
                    <g id="Tall_stand-3" data-name="Tall stand">
                        <rect class="cls-22" x="320" y="243.29" width="2.51" height="2.03"
                            transform="translate(375.66 644.22) rotate(-135)" />
                        <ellipse class="cls-22" cx="320.53" cy="245.03" rx="0.79" ry="1.25"
                            transform="translate(-79.38 298.42) rotate(-45)" />
                        <ellipse class="cls-74" cx="321.97" cy="243.59" rx="0.79" ry="1.25"
                            transform="translate(-77.94 299.01) rotate(-45)" />
                        <rect class="cls-22" x="367.91" y="243.29" width="2.51" height="2.03"
                            transform="translate(802.95 156.02) rotate(135)" />
                        <ellipse class="cls-22" cx="369.88" cy="245.03" rx="1.25" ry="0.79"
                            transform="translate(-64.92 333.31) rotate(-45)" />
                        <ellipse class="cls-74" cx="368.44" cy="243.59" rx="1.25" ry="0.79"
                            transform="translate(-64.33 331.88) rotate(-45)" />
                        <rect class="cls-157" x="346.15" y="124.79" width="1.14" height="33.19"
                            transform="translate(491.92 486.53) rotate(-135)" />
                        <rect class="cls-158" x="333.07" y="215.32" width="1.14" height="33.19"
                            transform="translate(405.57 631.83) rotate(-135)" />
                        <rect class="cls-22" x="349.09" y="238.4" width="1.73" height="1.11"
                            transform="translate(744.02 394.8) rotate(167.25)" />
                        <ellipse class="cls-22" cx="350.08" cy="239.5" rx="0.86" ry="0.43"
                            transform="translate(-44.22 83.15) rotate(-12.75)" />
                        <ellipse class="cls-74" cx="349.83" cy="238.41" rx="0.86" ry="0.43"
                            transform="translate(-43.98 83.07) rotate(-12.75)" />
                        <rect class="cls-159" x="347.46" y="220.57" width="0.79" height="18.18"
                            transform="translate(737.81 376.9) rotate(167.25)" />
                        <rect class="cls-160" x="356.2" y="215.32" width="1.14" height="33.19"
                            transform="translate(-59.5 320.21) rotate(-45)" />
                        <rect class="cls-161" x="342.02" y="225.91" width="0.28" height="8.19"
                            transform="translate(746.74 150.7) rotate(135)" />
                        <rect class="cls-162" x="348.23" y="225.91" width="0.28" height="8.19"
                            transform="translate(264.67 -178.97) rotate(45)" />
                        <rect class="cls-163" x="344.64" y="142.93" width="1.14" height="90.07"
                            transform="translate(690.42 375.92) rotate(-180)" />
                    </g>
                    <g id="Crashcymbal">
                        <path class="cls-164"
                            d="M336.41,131.87c0,2.59,10,4.68,22.33,4.68s22.34-2.09,22.34-4.68-10-5.72-22.34-5.72S336.41,129.28,336.41,131.87Z" />
                        <rect class="cls-22" x="357.59" y="128.42" width="2.31" height="0.76"
                            transform="translate(717.49 257.6) rotate(-180)" />
                        <ellipse class="cls-22" cx="358.74" cy="129.18" rx="1.15" ry="0.29" />
                        <ellipse class="cls-74" cx="358.74" cy="128.42" rx="1.15" ry="0.29" />
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>